<template>
  <div>
    <v-container fluid>
      <div class="main">
        <v-row justify="center" align="center">
          <v-col cols="12" lg="10">
            <v-card class="rounded-lg shadow">
              <v-card-text>
                <v-row align="center">
                  <v-col cols="4">
                    <h3 class="mb-5">Vérification des codes QR IFRI</h3>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
                      <g id="freepik--background-simple--inject-32">
                        <path
                            d="M459.24,137.52c-2.41-18.76-7.11-36.75-17-53.14C424,53.93,391,35.53,357.63,26.2c-28-7.82-58.16-10.08-86.09-2-30.66,8.87-56.39,29.29-84,45.3a437.69,437.69,0,0,1-63.1,29.66c-17.58,6.73-39.92,10.5-54.37,23.28a144.93,144.93,0,0,0-23.35,26.65C19.74,188.4,11,238.62,15.12,285.5c2.91,32.66,11.89,65.71,32,91.58,28.27,36.31,76.8,54.2,122.59,49.69,52-5.12,101.25-36.19,152.93-28.73,25.73,3.71,50.35,16.93,76.23,14.47,25.51-2.42,47.34-20,62.73-40.45,12.34-16.43,20.55-36.3,21.31-57,.83-22.39-9.31-42.81-14.4-64.19C459.66,213.5,464.09,175.27,459.24,137.52Z"
                            style="fill:#D60C56"></path>
                        <path
                            d="M459.24,137.52c-2.41-18.76-7.11-36.75-17-53.14C424,53.93,391,35.53,357.63,26.2c-28-7.82-58.16-10.08-86.09-2-30.66,8.87-56.39,29.29-84,45.3a437.69,437.69,0,0,1-63.1,29.66c-17.58,6.73-39.92,10.5-54.37,23.28a144.93,144.93,0,0,0-23.35,26.65C19.74,188.4,11,238.62,15.12,285.5c2.91,32.66,11.89,65.71,32,91.58,28.27,36.31,76.8,54.2,122.59,49.69,52-5.12,101.25-36.19,152.93-28.73,25.73,3.71,50.35,16.93,76.23,14.47,25.51-2.42,47.34-20,62.73-40.45,12.34-16.43,20.55-36.3,21.31-57,.83-22.39-9.31-42.81-14.4-64.19C459.66,213.5,464.09,175.27,459.24,137.52Z"
                            style="fill:#fff;opacity:0.7000000000000001"></path>
                      </g>
                      <g id="freepik--Furniture--inject-32">
                        <rect x="334.93" y="309.74" width="145.94" height="5.5"
                              transform="translate(815.8 624.98) rotate(180)"
                              style="fill:none;stroke:#263238;stroke-linecap:round;stroke-linejoin:round"></rect>
                        <rect x="341.7" y="315.4" width="132.4" height="148.6"
                              transform="translate(815.8 779.4) rotate(180)"
                              style="fill:none;stroke:#263238;stroke-linecap:round;stroke-linejoin:round"></rect>
                        <rect x="346.46" y="322.31" width="123.03" height="32.24"
                              transform="translate(815.96 676.87) rotate(180)"
                              style="fill:none;stroke:#263238;stroke-linecap:round;stroke-linejoin:round"></rect>
                        <rect x="402.04" y="335.47" width="12.3" height="5.94"
                              transform="translate(816.38 676.87) rotate(180)"
                              style="fill:#263238;stroke:#263238;stroke-linecap:round;stroke-linejoin:round"></rect>
                        <rect x="346.46" y="363.04" width="123.03" height="32.24"
                              transform="translate(815.96 758.33) rotate(180)"
                              style="fill:none;stroke:#263238;stroke-linecap:round;stroke-linejoin:round"></rect>
                        <rect x="402.04" y="376.19" width="12.3" height="5.94"
                              transform="translate(816.38 758.33) rotate(180)"
                              style="fill:#263238;stroke:#263238;stroke-linecap:round;stroke-linejoin:round"></rect>
                        <rect x="346.46" y="403.96" width="123.03" height="32.24"
                              transform="translate(815.96 840.16) rotate(180)"
                              style="fill:none;stroke:#263238;stroke-linecap:round;stroke-linejoin:round"></rect>
                        <rect x="402.04" y="417.11" width="12.3" height="5.94"
                              transform="translate(816.38 840.16) rotate(180)"
                              style="fill:#263238;stroke:#263238;stroke-linecap:round;stroke-linejoin:round"></rect>
                        <path
                            d="M414,244.73c1.49.65,5.14.57,5.14.57s-.78-2.39-.85-2.54c-.8-1.67-3.33-4.44-5.39-4.16a2.47,2.47,0,0,0-2,3.09A5.2,5.2,0,0,0,414,244.73Z"
                            style="fill:#263238"></path>
                        <path
                            d="M450.87,245.53s.66-2.42.68-2.58c.26-1.84-.33-5.54-2.2-6.45A2.46,2.46,0,0,0,446,238a5.18,5.18,0,0,0,.89,4.24C447.78,243.58,450.86,245.53,450.87,245.53Z"
                            style="fill:#263238"></path>
                        <path
                            d="M461.76,232.31c-2.07-.22-4.53,2.61-5.28,4.3-.07.15-.82,2.56-.78,2.56h0c-.39.44-.81.92-1.25,1.46-.81,1-1.71,2.12-2.61,3.42a42.76,42.76,0,0,0-2.71,4.31,31.47,31.47,0,0,0-2.32,5.22s0,0,0,.06c0-.61,0-2.31,0-2.44-.24-1.84-1.78-5.26-3.83-5.64a2.46,2.46,0,0,0-2.83,2.32,5.16,5.16,0,0,0,2,3.85c1.17,1,4.4,2.05,4.66,2.13a45.53,45.53,0,0,0-1.37,5.64c-.19,1.12-.36,2.24-.51,3.37,0-.52,0-1,0-1.06-.24-1.84-1.78-5.26-3.82-5.63a2.45,2.45,0,0,0-2.84,2.31,5.15,5.15,0,0,0,2,3.85,16.24,16.24,0,0,0,4.52,2.08c-.05.44-.11.87-.16,1.31-.25,2.08-.49,4.17-.79,6.2-.1.72-.23,1.42-.36,2.13,0-.47,0-.87,0-.93-.24-1.84-1.78-5.25-3.83-5.63a2.45,2.45,0,0,0-2.83,2.31,5.15,5.15,0,0,0,2,3.85,15.44,15.44,0,0,0,4.39,2c-.15.72-.3,1.44-.48,2.13-.14.46-.23.92-.39,1.38s-.3.92-.44,1.37c-.31.86-.63,1.75-1,2.58-.22.57-.44,1.12-.66,1.67.11-.71.3-2.11.3-2.23a9.57,9.57,0,0,0-1.28-4.65,2.55,2.55,0,0,0-3-2.63c-2,.54-3.28,4.06-3.38,5.92,0,.11.07,1.3.13,2.05-.11-.43-.2-.86-.31-1.31-.21-.89-.45-1.77-.7-2.71-.13-.46-.27-.92-.41-1.38s-.33-.93-.49-1.4c-.39-1.09-.85-2.17-1.33-3.25a16.24,16.24,0,0,0,4.63-1.74,5.13,5.13,0,0,0,2.26-3.69,2.46,2.46,0,0,0-2.66-2.52c-2.07.23-3.86,3.52-4.23,5.34,0,.11-.15,1.45-.2,2.18-.3-.65-.59-1.29-.91-1.94-.92-1.86-1.92-3.71-2.9-5.57-.3-.56-.59-1.13-.89-1.7.28-.07,3.57-.83,4.8-1.78a5.13,5.13,0,0,0,2.26-3.69,2.46,2.46,0,0,0-2.66-2.52c-2.06.23-3.86,3.52-4.23,5.34,0,.13-.2,2.05-.22,2.54-.65-1.25-1.29-2.5-1.87-3.77a42.82,42.82,0,0,1-2-5.24c.13,0,3.57-.81,4.83-1.78a5.13,5.13,0,0,0,2.26-3.69,2.46,2.46,0,0,0-2.66-2.52c-2.06.23-3.86,3.52-4.23,5.33,0,.12-.16,1.59-.21,2.29h-.11a30.93,30.93,0,0,1-1.06-5.55c-.12-1-.17-2-.2-3a16.54,16.54,0,0,0,4.88-1.22,5.15,5.15,0,0,0,2.65-3.43,2.46,2.46,0,0,0-2.37-2.79c-2.08,0-4.22,3.07-4.79,4.84,0,.09-.24,1.1-.38,1.84,0-.43,0-.88,0-1.3,0-1.58.1-3,.2-4.29.06-.72.13-1.38.2-2a16.47,16.47,0,0,0,3.75-3.32,5.14,5.14,0,0,0,.77-4.26,2.47,2.47,0,0,0-3.39-1.39c-1.84,1-2.33,4.67-2,6.5,0,.16.72,2.59.75,2.57l0,0c-.08.59-.16,1.22-.24,1.91-.12,1.27-.25,2.71-.29,4.29a44.58,44.58,0,0,0,.12,5.1,32.17,32.17,0,0,0,.94,5.62l0,.07c-.33-.52-1.29-1.92-1.38-2-1.21-1.4-4.39-3.4-6.3-2.59a2.46,2.46,0,0,0-1.09,3.49,5.15,5.15,0,0,0,3.77,2.13c1.55.22,4.8-.72,5.06-.8a44.47,44.47,0,0,0,2,5.47c.45,1,.93,2.06,1.43,3.09l-.61-.87c-1.22-1.41-4.39-3.4-6.3-2.59a2.45,2.45,0,0,0-1.09,3.49,5.15,5.15,0,0,0,3.77,2.13,16.35,16.35,0,0,0,4.92-.76c.2.39.39.79.58,1.18,1,1.88,1.89,3.75,2.77,5.61.31.65.59,1.31.87,2-.26-.39-.49-.71-.53-.76-1.21-1.4-4.39-3.4-6.3-2.59a2.47,2.47,0,0,0-1.09,3.5,5.17,5.17,0,0,0,3.77,2.12,15.93,15.93,0,0,0,4.79-.72c.27.68.54,1.36.77,2,.14.46.32.9.44,1.37l.39,1.38c.21.89.43,1.8.62,2.68.13.6.25,1.18.37,1.76-.3-.65-.91-1.93-1-2-1-1.57-3.82-4-5.83-3.51a2.47,2.47,0,0,0-1.61,3.29,5.16,5.16,0,0,0,3.41,2.67,16.81,16.81,0,0,0,5.09,0c.2,1,.38,1.91.53,2.8.34,1.95.6,3.7.8,5.19h-8.19v17.22h21.54V292.39h-8.33c.54-1.2,1.13-2.56,1.75-4.07.38-.93.77-1.93,1.16-2.95.39.08,3.59.73,5.08.39a5.12,5.12,0,0,0,3.59-2.4,2.45,2.45,0,0,0-1.35-3.4c-2-.67-5,1.57-6.08,3.07-.07.08-.67,1.12-1,1.78.16-.42.32-.83.47-1.26.32-.86.61-1.73.92-2.65.14-.46.27-.92.41-1.38s.25-1,.37-1.44c.27-1.13.49-2.28.68-3.45a15.86,15.86,0,0,0,4.82,1.11,5.1,5.1,0,0,0,3.92-1.83,2.46,2.46,0,0,0-.82-3.57c-1.85-.95-5.16.81-6.48,2.12-.08.08-.92,1.12-1.37,1.71.11-.71.22-1.41.31-2.12.26-2.06.45-4.16.66-6.24.06-.64.13-1.28.2-1.92.26.1,3.43,1.28,5,1.17,1.38-.1,3.12-.6,3.92-1.83a2.47,2.47,0,0,0-.83-3.57c-1.84-1-5.16.8-6.47,2.11-.1.1-1.31,1.61-1.59,2,.15-1.41.31-2.81.52-4.18a43.42,43.42,0,0,1,1.2-5.49c.12,0,3.42,1.29,5,1.18a5.14,5.14,0,0,0,3.92-1.83,2.46,2.46,0,0,0-.82-3.57c-1.85-.95-5.16.8-6.48,2.11-.09.09-1,1.24-1.43,1.79l-.1,0a31.55,31.55,0,0,1,2.18-5.22c.47-.92,1-1.78,1.48-2.6a16.72,16.72,0,0,0,4.75,1.67,5.17,5.17,0,0,0,4.1-1.4,2.46,2.46,0,0,0-.43-3.63c-1.74-1.15-5.22.23-6.67,1.39-.08.06-.81.79-1.34,1.33.24-.37.47-.76.71-1.1.86-1.31,1.74-2.46,2.53-3.47.45-.57.87-1.07,1.26-1.54a16.85,16.85,0,0,0,5-.71,5.12,5.12,0,0,0,3-3.12A2.45,2.45,0,0,0,461.76,232.31Zm-22.89,55.53c-.74,1.72-1.46,3.25-2.08,4.55H434.6c-.23-1.54-.54-3.37-1-5.42-.19-1-.42-2-.66-3.09a28.66,28.66,0,0,0,2.84-1.34,18,18,0,0,0,4.15,2.67C439.61,286.12,439.24,287,438.87,287.84Z"
                            style="fill:#263238"></path>
                      </g>
                      <g id="freepik--Plant--inject-32">
                        <line x1="28.47" y1="316.96" x2="40.07" y2="428.09"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <line x1="38.2" y1="406.82" x2="32.94" y2="401.27"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M34.54,402.93a6,6,0,0,0-2.09-4.46c-1.35-1.2-8.46-4.19-9.13-1.69C22.59,399.5,29.86,404.84,34.54,402.93Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="34.54" y1="402.93" x2="27.78" y2="398.72"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="39.52" y1="419.46" x2="34.26" y2="413.91"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M35.86,415.57a6,6,0,0,0-2.09-4.46c-1.35-1.2-8.46-4.19-9.13-1.69C23.91,412.14,31.18,417.48,35.86,415.57Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="35.86" y1="415.57" x2="29.1" y2="411.36"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="34.98" y1="375.98" x2="29.72" y2="370.43"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M31.32,372.09a6,6,0,0,0-2.09-4.46c-1.35-1.21-8.46-4.19-9.13-1.69C19.37,368.66,26.64,374,31.32,372.09Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="31.32" y1="372.09" x2="24.56" y2="367.88"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="36.3" y1="388.62" x2="31.04" y2="383.07"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M32.64,384.73a6,6,0,0,0-2.09-4.46c-1.35-1.21-8.46-4.19-9.13-1.69C20.69,381.3,28,386.64,32.64,384.73Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="32.64" y1="384.73" x2="25.88" y2="380.52"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="32.84" y1="355.45" x2="27.58" y2="349.89"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M29.18,351.56a5.94,5.94,0,0,0-2.1-4.46c-1.35-1.21-8.45-4.19-9.12-1.69C17.23,348.13,24.5,353.47,29.18,351.56Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="29.18" y1="351.56" x2="22.42" y2="347.35"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="30.69" y1="334.83" x2="25.43" y2="329.27"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M27,330.94a5.94,5.94,0,0,0-2.1-4.46c-1.35-1.21-8.45-4.2-9.12-1.69C15.07,327.51,22.34,332.85,27,330.94Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="27.03" y1="330.94" x2="20.26" y2="326.72"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="37.32" y1="399.34" x2="41.31" y2="392.82"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M40.09,394.78A6,6,0,0,1,41.22,390c1.07-1.46,7.4-5.85,8.58-3.54C51.08,389,45.07,395.69,40.09,394.78Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="40.09" y1="394.78" x2="46.18" y2="388.96"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="33.84" y1="366.08" x2="37.84" y2="359.56"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M36.62,361.52a6,6,0,0,1,1.13-4.79c1.07-1.46,7.4-5.85,8.58-3.54C47.61,355.7,41.6,362.43,36.62,361.52Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="36.62" y1="361.52" x2="42.71" y2="355.7"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="32.32" y1="351.47" x2="36.32" y2="344.95"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M35.1,346.91a6,6,0,0,1,1.12-4.8c1.08-1.46,7.41-5.85,8.58-3.54C46.08,341.08,40.07,347.81,35.1,346.91Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="35.1" y1="346.91" x2="41.19" y2="341.09"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="30.08" y1="330.04" x2="34.08" y2="323.52"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M32.86,325.48a6,6,0,0,1,1.13-4.8c1.07-1.46,7.4-5.85,8.58-3.54C43.85,319.65,37.84,326.38,32.86,325.48Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="32.86" y1="325.48" x2="38.95" y2="319.66"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <path
                            d="M28.37,316.34a6,6,0,0,1,1.13-4.8c1.07-1.46,7.4-5.85,8.58-3.54C39.36,310.51,33.35,317.24,28.37,316.34Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="28.37" y1="316.34" x2="34.46" y2="310.52"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <path
                            d="M28.73,316.59A6,6,0,0,1,24.07,315c-1.33-1.22-5-8-2.62-8.91C24.08,305.05,30.15,311.74,28.73,316.59Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="28.73" y1="316.59" x2="23.58" y2="309.92"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="59.06" y1="332.26" x2="47.53" y2="443.4"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <line x1="50.08" y1="422.2" x2="46.08" y2="415.69"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M47.3,417.64a6,6,0,0,0-1.13-4.79c-1.08-1.46-7.41-5.84-8.59-3.54C36.31,411.83,42.32,418.55,47.3,417.64Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="47.3" y1="417.64" x2="41.55" y2="412.13"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="53.28" y1="391.36" x2="49.28" y2="384.84"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M50.5,386.8A6,6,0,0,0,49.37,382c-1.07-1.46-7.41-5.85-8.58-3.54C39.51,381,45.52,387.71,50.5,386.8Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="50.5" y1="386.8" x2="44.75" y2="381.28"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="51.97" y1="404" x2="47.97" y2="397.48"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M49.19,399.44a6,6,0,0,0-1.13-4.79c-1.08-1.46-7.41-5.85-8.59-3.54C38.2,393.62,44.21,400.35,49.19,399.44Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="49.19" y1="399.44" x2="43.44" y2="393.92"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="55.41" y1="370.83" x2="51.41" y2="364.31"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M52.63,366.27a6,6,0,0,0-1.13-4.8c-1.07-1.45-7.41-5.84-8.58-3.53C41.64,360.45,47.65,367.18,52.63,366.27Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="52.63" y1="366.27" x2="46.88" y2="360.75"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="57.55" y1="350.21" x2="53.55" y2="343.69"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M54.77,345.65a6,6,0,0,0-1.13-4.8c-1.07-1.46-7.41-5.84-8.58-3.53C43.78,339.83,49.79,346.55,54.77,345.65Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="54.77" y1="345.65" x2="49.02" y2="340.13"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="50.75" y1="414.7" x2="56.01" y2="409.15"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M54.41,410.81a6,6,0,0,1,2.09-4.46c1.35-1.2,8.45-4.2,9.13-1.7C66.36,407.37,59.09,412.72,54.41,410.81Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="54.41" y1="410.81" x2="61.57" y2="406.37"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="54.2" y1="381.44" x2="59.46" y2="375.89"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M57.86,377.55A6,6,0,0,1,60,373.09c1.35-1.21,8.45-4.2,9.13-1.7C69.81,374.11,62.55,379.46,57.86,377.55Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="57.86" y1="377.55" x2="65.02" y2="373.11"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="55.72" y1="366.82" x2="60.98" y2="361.27"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M59.38,362.93a6,6,0,0,1,2.09-4.46c1.35-1.2,8.45-4.2,9.12-1.7C71.33,359.5,64.06,364.84,59.38,362.93Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="59.38" y1="362.93" x2="66.54" y2="358.49"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="57.94" y1="345.4" x2="63.2" y2="339.84"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M61.6,341.5A6,6,0,0,1,63.69,337c1.35-1.2,8.45-4.2,9.13-1.69C73.55,338.07,66.29,343.41,61.6,341.5Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="61.6" y1="341.5" x2="68.76" y2="337.06"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <path
                            d="M59.09,331.64a6,6,0,0,1,2.09-4.46c1.35-1.21,8.45-4.2,9.13-1.7C71,328.2,63.78,333.55,59.09,331.64Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="59.09" y1="331.64" x2="66.25" y2="327.2"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <path
                            d="M59.39,332a5.94,5.94,0,0,1-4.22-2.54c-1.06-1.47-3.29-8.84-.73-9.25C57.22,319.71,61.78,327.5,59.39,332Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="59.39" y1="331.95" x2="55.72" y2="324.37"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="45.84" y1="287" x2="45.84" y2="427.55"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <line x1="45.96" y1="406.42" x2="41.3" y2="400.35"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M42.72,402.17a6,6,0,0,0-1.62-4.66c-1.22-1.33-8-5-8.9-2.62C31.19,397.51,37.86,403.58,42.72,402.17Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="42.72" y1="402.17" x2="36.43" y2="397.28"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="45.96" y1="380" x2="41.3" y2="373.94"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M42.72,375.76a6,6,0,0,0-1.62-4.66c-1.22-1.34-8-5.05-8.9-2.63C31.19,371.1,37.86,377.17,42.72,375.76Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="42.72" y1="375.76" x2="36.43" y2="370.86"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="45.96" y1="349" x2="41.3" y2="342.93"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M42.72,344.75a6,6,0,0,0-1.62-4.66c-1.22-1.34-8-5-8.9-2.63C31.19,340.09,37.86,346.16,42.72,344.75Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="42.72" y1="344.75" x2="36.43" y2="339.85"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="45.96" y1="328.35" x2="41.3" y2="322.28"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M42.72,324.1a6,6,0,0,0-1.62-4.65c-1.22-1.34-8-5.05-8.9-2.63C31.19,319.45,37.86,325.52,42.72,324.1Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="42.72" y1="324.1" x2="36.43" y2="319.21"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="45.96" y1="307.62" x2="41.3" y2="301.55"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M42.72,303.37a6,6,0,0,0-1.62-4.65c-1.22-1.34-8-5.05-8.9-2.63C31.19,298.72,37.86,304.79,42.72,303.37Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="42.72" y1="303.37" x2="36.43" y2="298.48"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="45.85" y1="414.48" x2="50.51" y2="408.41"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M49.09,410.23a6,6,0,0,1,1.62-4.65c1.22-1.34,8-5.05,8.9-2.63C60.62,405.58,54,411.65,49.09,410.23Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="49.09" y1="410.23" x2="55.75" y2="405.08"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="45.85" y1="372.47" x2="50.51" y2="366.41"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M49.09,368.23a6,6,0,0,1,1.62-4.66c1.22-1.34,8-5,8.9-2.63C60.62,363.57,54,369.64,49.09,368.23Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="49.09" y1="368.23" x2="55.75" y2="363.07"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="45.85" y1="351.74" x2="50.51" y2="345.67"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M49.09,347.49a6,6,0,0,1,1.62-4.65c1.22-1.34,8-5,8.9-2.63C60.62,342.84,54,348.91,49.09,347.49Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="49.09" y1="347.49" x2="55.75" y2="342.34"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="45.85" y1="324.34" x2="50.51" y2="318.27"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M49.09,320.09a6,6,0,0,1,1.62-4.65c1.22-1.34,8-5.05,8.9-2.63C60.62,315.44,54,321.51,49.09,320.09Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="49.09" y1="320.09" x2="55.75" y2="314.93"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <line x1="45.85" y1="302.79" x2="50.51" y2="296.72"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:2px"></line>
                        <path
                            d="M49.09,298.55a6,6,0,0,1,1.62-4.66c1.22-1.34,8-5.05,8.9-2.63C60.62,293.89,54,300,49.09,298.55Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="49.09" y1="298.55" x2="55.75" y2="293.39"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <path
                            d="M45.58,289a5.93,5.93,0,0,1,1.61-4.65c1.22-1.34,8-5,8.91-2.63C57.11,284.34,50.43,290.41,45.58,289Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="45.58" y1="288.99" x2="52.24" y2="283.83"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <path
                            d="M45.9,289.28a6,6,0,0,1-4.46-2.1c-1.2-1.35-4.18-8.46-1.68-9.13C42.48,277.32,47.82,284.6,45.9,289.28Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="45.9" y1="289.28" x2="41.47" y2="282.11"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:0.5px"></line>
                        <polygon points="51.63 464 36.74 464 34.88 426.41 53.49 426.41 51.63 464"
                                 style="fill:#263238;stroke:#263238;stroke-miterlimit:10"></polygon>
                      </g>
                      <g id="freepik--Picture--inject-32">
                        <polyline
                            points="115.08 176.18 25.66 176.18 25.66 33.83 136.37 33.83 136.37 176.18 120.89 176.18"
                            style="fill:none;stroke:#263238;stroke-miterlimit:10"></polyline>
                        <rect x="29.68" y="38.99" width="102.68" height="132.03"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></rect>
                        <path d="M50.25,75.15a48.89,48.89,0,0,0,5.81,4.61c23.23,15.76,62.63,8.3,75.9,30.69"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                        <path d="M36.57,39.53A42.92,42.92,0,0,0,47.35,72.22"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                        <path d="M45.37,112.26c11.33-6,26-10.23,33.51,1.92,8.71,14.11-31.53,39-31.53,56.82"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                        <path d="M29.94,122.48A98.4,98.4,0,0,1,42.24,114"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                        <path d="M83.44,39.53s14.93,23.23,48.94,17"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                        <path d="M87.9,62.34A13,13,0,0,1,88,64a13.67,13.67,0,1,1-1.58-6.4"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                        <path d="M122,82.46A6.43,6.43,0,1,1,115.58,76,6.42,6.42,0,0,1,122,82.46Z"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                        <path d="M122.09,125.83a26.28,26.28,0,0,1,9.91,5"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                        <path d="M97.46,171.1A26.54,26.54,0,0,1,115.37,125c.52,0,1,0,1.53,0"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                      </g>
                      <g id="freepik--Floor--inject-32">
                        <line x1="322" y1="464" x2="481" y2="464"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></line>
                        <line x1="16" y1="464" x2="314" y2="464"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></line>
                      </g>
                      <g id="freepik--Device--inject-32">
                        <rect x="193.7" y="42.5" width="201.83" height="373.89" style="fill:#fff"></rect>
                        <rect x="193.7" y="352.63" width="201.83" height="63.76" style="fill:#dedede"></rect>
                        <path
                            d="M401.59,116.06a2.49,2.49,0,0,0,2.49-2.49V88.64a2.49,2.49,0,0,0-2.49-2.49,2.42,2.42,0,0,0-.47,0V39.56a16.07,16.07,0,0,0-16.07-16.07H207.9a16.07,16.07,0,0,0-16.08,16.07V415.85a16.08,16.08,0,0,0,16.08,16.08H385.05a16.08,16.08,0,0,0,16.07-16.08V186.93a2.42,2.42,0,0,0,.47,0,2.5,2.5,0,0,0,2.49-2.5V159.55a2.49,2.49,0,0,0-2.49-2.49,2.42,2.42,0,0,0-.47.05v-5.64a2.42,2.42,0,0,0,.47.05,2.5,2.5,0,0,0,2.49-2.49V124.09a2.5,2.5,0,0,0-2.49-2.49,2.42,2.42,0,0,0-.47.05V116A2.42,2.42,0,0,0,401.59,116.06Zm-9.78,291.63H201.13V51.22H391.81Z"
                            style="fill:#263238"></path>
                        <rect x="369.51" y="54.92" width="15.81" height="8.67"
                              style="fill:none;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.821067px"></rect>
                        <rect x="369.51" y="54.92" width="12.33" height="8.67"
                              style="fill:#263238;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.725073px"></rect>
                        <rect x="385.29" y="57.35" width="2.23" height="3.82"
                              style="fill:#263238;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.725073px"></rect>
                        <rect x="205.42" y="57.61" width="2.9" height="4.97"
                              style="fill:#263238;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.8830859999999999px"></rect>
                        <rect x="209.98" y="55.87" width="2.9" height="6.71"
                              style="fill:#263238;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.8830859999999999px"></rect>
                        <rect x="214.53" y="53.8" width="2.9" height="8.78"
                              style="fill:#263238;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.8830859999999999px"></rect>
                        <rect x="204.2" y="68.41" width="183.11" height="48.12" style="fill:#D60C56"></rect>
                        <line x1="250.48" y1="75.34" x2="250.48" y2="110.67"
                              style="fill:none;stroke:#fff;stroke-miterlimit:10"></line>
                        <line x1="297.14" y1="75.34" x2="297.14" y2="110.67"
                              style="fill:none;stroke:#fff;stroke-miterlimit:10"></line>
                        <line x1="343.81" y1="75.34" x2="343.81" y2="110.67"
                              style="fill:none;stroke:#fff;stroke-miterlimit:10"></line>
                        <path
                            d="M399.47,186.93a2.42,2.42,0,0,0,.47,0,2.5,2.5,0,0,0,2.49-2.5v-8.93l-12.27,21.63V407.69H270.79L257,431.93H383.39a16.08,16.08,0,0,0,16.08-16.08Z"
                            style="fill:#fff;opacity:0.15"></path>
                      </g>
                      <g id="freepik--qr-code--inject-32">
                        <path
                            d="M288.73,282.43V271l0,0h5.71v-5.75h-5.69c0-1.91,0-3.83,0-5.74H300.2v-5.71h5.72v5.68h5.74V248h17.2v5.71h5.69V248h-5.71v-5.76H317.37V230.86H300.16v5.72H288.75v11.47h5.68v5.72h-5.71v5.73H283v-5.74H265.81v-5.71H283V202.17h5.75v0q0,8.28,0,16.56v.62h5.73V207.92h5.71v11.45h5.76v5.71h28.66v5.72h5.74v5.77l0,0h-5.71v5.75h5.69v11.48h5.75l0,0v11.46h-5.69V276.7H346v5.73h11.45v5.72H340.33V299.6h-5.72v-5.72h-11.5l0,0v-5.73h-5.72v-5.72h11.41v-5.73H300.21v5.7H288.73Zm34.38-17.2v-5.7h-5.69v5.69h5.71v5.71h11.42v-5.7Zm-11.48,0H306v5.67h5.67Zm11.51-28.73h5.67v-5.68h-5.67Z"
                            style="fill:#263238"></path>
                        <path d="M237.14,219.33V179.25h40.07v40.08ZM242.89,185v28.61h28.6V185Z"
                              style="fill:#263238"></path>
                        <path d="M357.48,219.34H317.41V179.27h40.07ZM351.76,185h-28.6v28.6h28.6Z"
                              style="fill:#263238"></path>
                        <path d="M237.15,259.51h40.08v40.08H237.15Zm34.35,5.75H242.89v28.61H271.5Z"
                              style="fill:#263238"></path>
                        <path
                            d="M288.72,202.17V190.7H283V179.26h28.61v11.42H306v5.74h5.67v11.44h-5.71v-5.69H300.2v-5.72h-5.72v5.7h-5.77Zm5.75-11.51h5.68V185h-5.68Z"
                            style="fill:#263238"></path>
                        <path d="M265.78,230.82v5.73h11.45v5.72H260.06v11.46h-22.9v-11.4h5.67V248h11.5V230.82h11.46Z"
                              style="fill:#263238"></path>
                        <path d="M288.71,282.42v5.73h5.73v5.72h5.71v5.73H283V282.43h5.69Z" style="fill:#263238"></path>
                        <path d="M254.33,230.82H242.87v5.71h-5.71v-11.4h17.15v5.7Z" style="fill:#263238"></path>
                        <path d="M357.48,242.27H351.8V230.84h-5.72v-5.72h11.4Z" style="fill:#263238"></path>
                        <path d="M265.79,230.84v-5.71h11.43v5.69H265.78Z" style="fill:#263238"></path>
                        <path d="M346.06,253.77v-5.71h5.69v5.69H346Z" style="fill:#263238"></path>
                        <path d="M351.81,259.52h5.67v5.68h-5.67Z" style="fill:#263238"></path>
                        <path d="M305.92,219.37v-5.71h5.7v5.69h-5.71Z" style="fill:#263238"></path>
                        <path d="M288.73,271H283v-5.72h5.69V271Z" style="fill:#263238"></path>
                        <path d="M346.06,276.7V271h5.69v5.69h-5.69Z" style="fill:#263238"></path>
                        <path d="M340.31,236.57H346v5.72h-5.69v-5.75Z" style="fill:#263238"></path>
                        <path d="M311.62,293.87h-5.68V288.2h5.68Z" style="fill:#263238"></path>
                        <path d="M323.11,293.88v5.71h-5.69V293.9h5.71Z" style="fill:#263238"></path>
                        <path d="M357.48,299.61h-5.67v-5.68h5.67Z" style="fill:#263238"></path>
                        <path d="M311.66,248H306v-5.69h5.7V248Z" style="fill:#263238"></path>
                        <path d="M265.75,207.87H248.61V190.73h17.14Z" style="fill:#263238"></path>
                        <path d="M328.87,207.86V190.72H346v17.14Z" style="fill:#263238"></path>
                        <path d="M248.61,288.13V271h17.14v17.14Z" style="fill:#263238"></path>
                        <polyline points="253.79 165.67 228.69 165.67 228.69 193.36"
                                  style="fill:none;stroke:#D60C56;stroke-miterlimit:10;stroke-width:2px"></polyline>
                        <polyline points="345.07 165.67 370.16 165.67 370.16 193.36"
                                  style="fill:none;stroke:#D60C56;stroke-miterlimit:10;stroke-width:2px"></polyline>
                        <polyline points="253.79 311.49 228.69 311.49 228.69 283.8"
                                  style="fill:none;stroke:#D60C56;stroke-miterlimit:10;stroke-width:2px"></polyline>
                        <polyline points="345.07 311.49 370.16 311.49 370.16 283.8"
                                  style="fill:none;stroke:#D60C56;stroke-miterlimit:10;stroke-width:2px"></polyline>
                      </g>
                      <g id="freepik--Character--inject-32">
                        <rect x="166.42" y="171.67" width="13.67" height="28.67" rx="2.67"
                              style="fill:#263238;stroke:#263238;stroke-miterlimit:10"></rect>
                        <rect x="167.62" y="174.2" width="11.25" height="23.6"
                              style="fill:#fff;stroke:#263238;stroke-miterlimit:10"></rect>
                        <path
                            d="M57.66,312.17A21.6,21.6,0,0,0,69,308.88c-.22,6.38-.39,11.21-.39,11.21s1.1,1.92,1.65,2.75,5.22,3.57,5.77,6.05,3,3.85,2.75,7.42-3.3-.28-2.75.55,2.2,3.57,2.2,6.05-5.22,2.47-7.15.82-8.24-5.5-8.79-9.07l-2.15-8Z"
                            style="fill:#fff;stroke:#263238;stroke-miterlimit:10"></path>
                        <path d="M69.08,332l1.34,6s4.33,3.33,4.66,5.67"
                              style="fill:#fff;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="76.02" y1="336.86" x2="74.08" y2="333"
                              style="fill:#fff;stroke:#263238;stroke-miterlimit:10"></line>
                        <path
                            d="M90.69,458.77s-1.57,12.87-.35,14.44A9.17,9.17,0,0,0,96.25,477c2.78.35,7.48-1.22,7.48-1.22a28.38,28.38,0,0,0,9.74.87c5-.52,8.34-2.43,8.69-4.87s-4-3.47-6.43-6.08-6.31-7.23-6.31-7.23l-1-3.38s-5.91,3-9.73,3.13a23.11,23.11,0,0,1-6.44-.52Z"
                            style="fill:#fff;stroke:#263238;stroke-miterlimit:10"></path>
                        <path
                            d="M122.16,471.81a1.86,1.86,0,0,0-.08-.85c-1.15.48-2.62,1.06-4.44,1.72-5.22,1.92-7.83.35-10.43.35s-2.79,2.78-10.09.87c-4.77-1.25-6.56-2.86-7.24-3.84a6.86,6.86,0,0,0,.46,3.15A9.17,9.17,0,0,0,96.25,477c2.78.35,7.48-1.22,7.48-1.22a28.38,28.38,0,0,0,9.74.87C118.51,476.16,121.81,474.25,122.16,471.81Z"
                            style="fill:#fff;stroke:#263238;stroke-miterlimit:10"></path>
                        <path
                            d="M81.42,299s-7,23.5-4.5,40,14.5,47.5,14.5,47.5-1.5,11.5-1.5,15.5-3.5,11.5-1,19.5,2.5,29,2.5,30.5-1,9.5-1,9.5,2,3,9.5,3,9.5-6,9.5-6,7.5-44.5,7.5-51.5,8-33,11-43.5a89.6,89.6,0,0,1,8.65-20.68c2-3.5.85-45.82.85-45.82l-57-5Z"
                            style="fill:#737373;stroke:#263238;stroke-miterlimit:10"></path>
                        <path
                            d="M120.77,462.08s7.48,2.95,11.13,4.69,6.08,1.91,6.08,4.7-6.6,5.56-10.6,6.26-10.44.52-11.13.69-13.74,2.09-15.3-1.22.17-14.6.17-14.6A50.57,50.57,0,0,0,120.77,462.08Z"
                            style="fill:#fff;stroke:#263238;stroke-miterlimit:10"></path>
                        <path
                            d="M116.25,478.42c.69-.17,7.13,0,11.13-.69s10.6-3.48,10.6-6.26a3.56,3.56,0,0,0-.16-1.08,48.36,48.36,0,0,1-5.23,2.64c-4.87,2.09-11.3,3.48-21,3.31a44.88,44.88,0,0,1-11.14-1.43,7.34,7.34,0,0,0,.54,2.29C102.51,480.51,115.55,478.6,116.25,478.42Z"
                            style="fill:#fff;stroke:#263238;stroke-miterlimit:10"></path>
                        <path
                            d="M137.92,301s3,40.5-3,71-16,72-16.5,74,3.5,7.5,3.5,7.5v8s-3.5,3.5-11.5,4.5-10.5-1.5-10.5-1.5-2-13.5-2-23,2-42,2-42,4.5-33,4-38-2-20.5-2-20.5l-8-9.5"
                            style="fill:#737373;stroke:#263238;stroke-miterlimit:10"></path>
                        <path
                            d="M53.87,293.38l15.73-2.76c-.07,2.13.38-11.33.38-12.33,0-2.2,5.22-16,5.22-16s4.12,17.88,4.12,20.08-1.65,19,.55,21.17,9.9,6.6,26.95,6.05,29.7-1.93,33-5.23-.55-13.47-.83-14.84,4.4-37.4,4.4-37.4,18.42,19.25,29.42,16.5S178.59,223,178.59,223l.55-12.37s3.57-9.07,3.57-10.45-3.57-11.27-3.57-11.27-2.2-1.93-3.58,2.75a45.12,45.12,0,0,0-1.65,7.7s-3.3,2.47-3,6.05a23.65,23.65,0,0,0,1.37,6.32L164.84,236s-8.25-9.35-8.8-11-.28-7.7-7.15-11.28-20.9-3.85-20.9-3.85l-38.77.28S71.07,211.75,67,215.32s-16.77,48.95-16.77,55.82c0,2.15,1.12,8.81,2.69,17.05Z"
                            style="fill:#fff;stroke:#263238;stroke-miterlimit:10"></path>
                        <path d="M179.14,188.93s-.83,6.87-.28,8.25a15.36,15.36,0,0,1,.55,7.42"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                        <path
                            d="M172.81,268.67c11-2.75,5.78-45.65,5.78-45.65l.12-2.77a9.94,9.94,0,0,0-8.54-1.69L164.84,236s-8.25-9.35-8.8-11-.28-7.7-7.15-11.28-20.9-3.85-20.9-3.85l-38.77.28S71.07,211.75,67,215.32s-16.77,48.95-16.77,55.82c0,4.08,4.06,24.42,7.48,41A21.6,21.6,0,0,0,69,308.88c.4-11.89,1-29.16,1-30.59,0-2.2,5.22-16,5.22-16s4.12,17.88,4.12,20.08-1.65,19,.55,21.17,9.9,6.6,26.95,6.05,29.7-1.93,33-5.23-.55-13.47-.83-14.84,4.4-37.4,4.4-37.4S161.81,271.42,172.81,268.67Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <polyline points="69.8 247.21 75.2 262.34 64.08 243.33"
                                  style="fill:none;stroke:#263238;stroke-miterlimit:10"></polyline>
                        <line x1="66.75" y1="238.67" x2="68.66" y2="244.02"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></line>
                        <path d="M104.83,248.28c2.43,5.46,6,12.31,10.25,16.72"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                        <path d="M101.42,239.67s.75,2.25,2.09,5.52"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                        <path d="M107.42,258s6,12,9,14.33" style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                        <line x1="152.8" y1="243.45" x2="155.08" y2="241.33"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></line>
                        <polyline points="149.08 240.33 143.39 252.17 150.73 245.37"
                                  style="fill:none;stroke:#263238;stroke-miterlimit:10"></polyline>
                        <path d="M175.08,247c-.33-2.33-10.24-11.05-10.24-11.05s10.24,4.05,12.91,7.72"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                        <path
                            d="M131.84,173.8s.55,6.88,1.38,8,1.37,9.62,0,12.1-2.2,5.5-3,6.32-3.85.83-5,.83-13.47-.55-13.47-.55l.28-17.33S115.07,170.23,131.84,173.8Z"
                            style="fill:#fff;stroke:#263238;stroke-miterlimit:10"></path>
                        <path
                            d="M109.85,154.56S98.57,158.13,96.1,168s5.5,21.17,5.5,21.17,2.2,8,4.12,9.63,9.62,0,12.1-.55,8-15.4,8-15.4,0,3.57,1.65,3.57,1.38-4.67,1.38-5.5,7.7-6.6,7.7-16.49S128,150.16,120,150.71,109.85,154.56,109.85,154.56Z"
                            style="fill:#263238;stroke:#263238;stroke-miterlimit:10"></path>
                        <path
                            d="M133.22,209.27s-1.65-5.77-2.48-6.59-6.05-4.13-14.57-4.68-21.17-.27-22.27.28-1.38,5.22-1.38,5.22-3.57,3.3-4.4,5.23-1.65,2.74,6,9.07,11.83,8.8,19.8,6.87,19.52-13.47,19.52-13.47Z"
                            style="fill:#D60C56;stroke:#263238;stroke-miterlimit:10"></path>
                        <path d="M113.55,213.17A83.29,83.29,0,0,0,129.09,206"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                        <path d="M92.52,204.6s5,9.9,13.75,9.9a18.92,18.92,0,0,0,3.55-.38"
                              style="fill:none;stroke:#263238;stroke-miterlimit:10"></path>
                      </g>
                    </svg>
                  </v-col>
                  <v-col cols="8" class="pa-10">
                    <v-alert
                        type="success"
                        v-if="message && message.winning_amount > 0"
                        dismissible
                    >
                      Le montant gagné est de {{ message.winning_amount }} DA. <br>
                      Il a été transféré vers le compte {{ message.phone }}.
                    </v-alert>

                    <v-alert
                        type="warning"
                        v-if="message && message.winning_amount === 0"
                        dismissible
                    >
                      Aucun gain trouvé pour ce QR code.
                    </v-alert>

                    <p class="mb-4 font-weight-medium">
                      Entrer le numéro de téléphone du compte Gifty *
                    </p>
                    <v-text-field v-model="phone"
                                  outlined
                                  :error-messages="errors.phone"
                                  placeholder="Numéro de téléphone"
                                  type="tel"
                    ></v-text-field>

                    <div class="mb-4 font-weight-medium d-flex justify-space-between align-center">
                      Coller la valeur du code QR *
                      <v-btn color="gifty" text @click="openDialog" class="v-btn--active">
                        <v-icon left>mdi-qrcode</v-icon>
                        Générer un code QR
                      </v-btn>
                    </div>

                    <v-textarea v-model="boosting_code"
                                rows="7"
                                outlined
                                :error-messages="errors.boosting_code"
                                placeholder="QR code"
                    ></v-textarea>

                    <v-btn
                        block
                        large
                        depressed
                        dark
                        color="gifty"
                        :loading="isLoading"
                        @click="check"
                    >
                      <v-icon left>mdi-magnify</v-icon>
                      Vérifier
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

      </div>


      <v-dialog width="600" scrollable v-model="dialog">
        <v-card>
          <v-card-title>
            Générer un code QR
            <v-spacer/>
            <v-icon @click="dialog = false">mdi-close</v-icon>
          </v-card-title>
          <v-divider/>
          <v-card-text class="pa-8">

            <v-autocomplete v-model.trim="payload.ref"
                            :items="codes"
                            dense
                            outlined
                            label="Référence *"
            ></v-autocomplete>

            <v-text-field v-model.trim="payload.total"
                          dense
                          outlined
                          label="Total *"
            ></v-text-field>

            <v-text-field v-model.trim="payload.client"
                          dense
                          outlined
                          label="Client *"
            ></v-text-field>

            <v-select v-model.trim="payload.supplier"
                      dense
                      :items='["BIBI SID AHMED", "MOKRANE ALI", "EURL AL FURAT SERVICES PUBLICS", "EURL LA VAGUE VENTE ET DISTRIBUTION"]'
                      outlined
                      label="Dstributeur *"
            ></v-select>

            <v-text-field v-model.trim="payload.date"
                          dense
                          outlined
                          label="Date *"
                          type="datetime-local"
            ></v-text-field>


          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn depressed
                   class="white--text"
                   :disabled="!isFormValid"
                   color="gifty"
                   @click="generateQrCode"
            >
              <v-icon left>mdi-qrcode</v-icon>
              Générer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


    </v-container>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import jwtEncode from "jwt-encode";

export default {
  data() {
    return {
      dialog: false,
      isLoading: false,
      phone: null,
      boosting_code: null,
      errors: {},
      message: {},
      payload: {},
    };
  },
  methods: {
    openDialog() {
      this.payload = {}
      this.dialog = true
    },
    generateQrCode() {
      const SECRET = "AJZ3rAO72V5nIGnUh4DXUtPZr3jiAPnHtRyhHkmkk";
      const exp = Math.floor(Date.now() / 1000) + 60 * 60 * 24;

      const val = this.payload.date;
      if (!val) return;

      const d = new Date(val);
      const pad = n => String(n).padStart(2, "0");

      const date =
          `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ` +
          `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

      const data = {
        iss: "com.sigservice.sfa",
        TOTAL: this.payload.total,
        CLIENT: this.payload.client,
        REF: this.payload.ref,
        DISTRIBUTEUR: this.payload.supplier,
        TOURNEE: "T/25/IFRI/W16C02/01/10841",
        DATE: date,
        exp: exp
      };

      this.dialog = false;
      this.boosting_code = jwtEncode(data, SECRET);
    },
    check() {
      this.isLoading = true
      this.errors = {}
      this.message = {}

      let formattedPhone = this.phone;
      if (formattedPhone?.startsWith('0')) {
        formattedPhone = '+213' + formattedPhone.slice(1);
      }

      HTTP.post('/v1/mobile/boosting/check/code/web', {
        phone: formattedPhone,
        boosting_code: this.boosting_code,
        boosting_method_id: 4,
        platform_used: "web",
      }).then((res) => {
        this.isLoading = false

        this.message = res.data
        this.message.phone = formattedPhone
        this.phone = null
        this.boosting_code = null

      }).catch(err => {
        this.isLoading = false
        this.errors = err.response?.data?.errors || {};
        console.log(err)
      })
    },
    isValidDateTime (val) {
      if (!val) return false
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(val)
    }
  },
  computed : {
    isFormValid () {
      return (
          this.payload.ref &&
          this.payload.total &&
          this.payload.client &&
          this.payload.supplier &&
          this.isValidDateTime(this.payload.date)
      )
    },
    codes(){
      return [
        "22/IFRI/W09C02/00005002",
        "23/IFRI/W16C02/00000023",
        "22/IFRI/W09C02/00007490",
        "21/IFRI/06/00010157",
        "22/IFRI/W16C02/00000634",
        "22/IFRI/W09C02/00011373",
        "22/IFRI/W16C02/00000580",
        "22/IFRI/W09C02/00007593",
        "22/IFRI/W16C02/00000861",
        "22/IFRI/W09C02/00007480",
        "22/IFRI/W16C02/00000799",
        "24/IFRI/W16C02/00000327",
        "22/IFRI/W09C02/00008879",
        "22/IFRI/W16C02/00000950",
        "22/IFRI/W16C02/00000534",
        "22/IFRI/W16C02/00000402",
        "21/IFRI/06/00007696",
        "22/IFRI/W16C02/00000942",
        "21/IFRI/03/00001281",
        "21/IFRI/03/00002332",
        "21/IFRI/03/00001934",
        "22/IFRI/W09C02/00007332",
        "22/IFRI/W09C02/00011377",
        "22/IFRI/W09C02/00006312",
        "21/IFRI/03/00002304",
        "23/IFRI/W16C02/00000108",
        "21/IFRI/06/00010159",
        "23/IFRI/W16C02/00000322",
        "24/IFRI/W16C02/00000138",
        "23/IFRI/W16C02/00000067",
        "21/IFRI/06/00009975",
        "22/IFRI/W16C02/00000630",
        "24/IFRI/W16C02/00000299",
        "22/IFRI/W16C02/00000204",
        "22/IFRI/W16C02/00000558",
        "24/IFRI/W16C02/00000220",
        "22/IFRI/W09C02/00011359",
        "22/IFRI/W16C02/00000802",
        "24/IFRI/W16C02/00000119",
        "22/IFRI/W09C02/00007384",
        "22/IFRI/W09C02/00007338",
        "23/IFRI/W16C02/00000332",
        "22/IFRI/W09C02/00007462",
        "25/IFRI/W16C02/00000078",
        "24/IFRI/W16C02/00000290",
        "22/IFRI/W16C02/00000449",
        "22/IFRI/W09C02/00007529",
        "911_1747811856743",
        "22/IFRI/W09C02/00007406",
        "23/IFRI/W16C02/00000159",
        "21/IFRI/03/00002308",
        "22/IFRI/W09C02/00010626",
        "24/IFRI/W16C02/00000201",
        "24/IFRI/W16C02/00000307",
        "24/IFRI/W16C02/00000001",
        "21/IFRI/06/00009846",
        "22/IFRI/W09C02/00008838",
        "21/IFRI/06/00009411",
        "22/IFRI/W09C02/00007474",
        "22/IFRI/W09C02/00004864",
        "24/IFRI/W16C02/00000174",
        "22/IFRI/W09C02/00004171",
        "24/IFRI/W16C02/00000202",
        "24/IFRI/W16C02/00000123",
        "22/IFRI/W09C02/00006307",
        "22/IFRI/W16C02/00000967",
        "21/IFRI/06/00007751",
        "24/IFRI/W16C02/00000177",
        "21/IFRI/03/00002356",
        "24/IFRI/W16C02/00000162",
        "23/IFRI/W16C02/00000214",
        "24/IFRI/W16C02/00000292",
        "24/IFRI/W16C02/00000416",
        "24/IFRI/W16C02/00000331",
        "22/IFRI/W09C02/00004897",
        "24/IFRI/W16C02/00000470",
        "22/IFRI/W09C02/00005967",
        "21/IFRI/03/00001762",
        "22/IFRI/W16C02/00000972",
        "22/IFRI/W09C02/00004918",
        "23/IFRI/W16C02/00000233",
        "23/IFRI/W16C02/00000275",
        "24/IFRI/W16C02/00000241",
        "22/IFRI/W09C02/00009778",
        "24/IFRI/W16C02/00000199",
        "23/IFRI/W16C02/00000134",
        "22/IFRI/W16C02/00000995",
        "21/IFRI/06/00007798",
        "21/IFRI/03/00001282",
        "22/IFRI/W16C02/00000547",
        "22/IFRI/W09C02/00007542",
        "21/IFRI/06/00008130",
        "21/IFRI/03/00002552",
        "24/IFRI/W16C02/00000152",
        "24/IFRI/W16C02/00000064",
        "23/IFRI/W16C02/00000354",
        "22/IFRI/W09C02/00007575",
        "24/IFRI/W16C02/00000115",
        "22/IFRI/W09C02/00004917",
        "22/IFRI/W09C02/00010699",
        "24/IFRI/W16C02/00000583",
        "24/IFRI/W16C02/00000293",
        "24/IFRI/W16C02/00000542",
        "23/IFRI/W16C02/00000318",
        "24/IFRI/W16C02/00000002",
        "25/IFRI/W16C02/00000172",
        "21/IFRI/06/00009926",
        "21/IFRI/03/00002030",
        "24/IFRI/W16C02/00000148",
        "21/IFRI/06/00010255",
        "22/IFRI/W09C02/00008872",
        "22/IFRI/W16C02/00000043",
        "21/IFRI/03/00001579",
        "21/IFRI/03/00002619",
        "22/IFRI/W09C02/00007507",
        "22/IFRI/W09C02/00007350",
        "24/IFRI/W16C02/00000598",
        "22/IFRI/W16C02/00000975",
        "22/IFRI/W09C02/00007437",
        "22/IFRI/W16C02/00000544",
        "24/IFRI/W16C02/00000259",
        "21/IFRI/03/00002312",
        "24/IFRI/W16C02/00000247",
        "21/IFRI/03/00001753",
        "24/IFRI/W16C02/00000106",
        "21/IFRI/06/00008004",
        "22/IFRI/W09C02/00011371",
        "21/IFRI/03/00001355",
        "24/IFRI/W16C02/00000082",
        "22/IFRI/W09C02/00007355",
        "24/IFRI/W16C02/00000150",
        "24/IFRI/W16C02/00000102",
        "22/IFRI/W16C02/00000461",
        "24/IFRI/W16C02/00000326",
        "23/IFRI/W16C02/00000342",
        "21/IFRI/06/00009867",
        "22/IFRI/W16C02/00000654",
        "24/IFRI/W16C02/00000157",
        "25/IFRI/W16C02/00000092",
        "21/IFRI/03/00002329",
        "22/IFRI/W16C02/00000407",
        "22/IFRI/W09C02/00008169",
        "22/IFRI/W09C02/00004413",
        "25/IFRI/W16C02/00000027",
        "24/IFRI/W16C02/00000101",
        "24/IFRI/W16C02/00000375",
        "21/IFRI/06/00010079",
        "22/IFRI/W09C02/00008840",
        "22/IFRI/W16C02/00000473",
        "22/IFRI/W09C02/00008792",
        "24/IFRI/W16C02/00000186",
        "22/IFRI/W09C02/00004176",
        "25/IFRI/W16C02/00000061",
        "21/IFRI/03/00001932",
        "24/IFRI/W16C02/00000636",
        "24/IFRI/W16C02/00000109",
        "21/IFRI/03/00002706",
        "21/IFRI/06/00002644",
        "22/IFRI/W09C02/00008791",
        "22/IFRI/W09C02/00004928",
        "21/IFRI/03/00002687",
        "25/IFRI/W16C02/00000152",
        "25/IFRI/W16C02/00000109",
        "22/IFRI/W09C02/00004748",
        "22/IFRI/W09C02/00007530",
        "22/IFRI/W16C02/00000448",
        "22/IFRI/W09C02/00006195",
        "22/IFRI/W16C02/00000945",
        "22/IFRI/W16C02/00000936",
        "21/IFRI/03/00002309",
        "24/IFRI/W16C02/00000304",
        "21/IFRI/06/00008052",
        "23/IFRI/W16C02/00000068",
        "24/IFRI/W16C02/00000311",
        "21/IFRI/03/00001357",
        "23/IFRI/W16C02/00000363",
        "21/IFRI/06/00009881",
        "21/IFRI/03/00001520",
        "22/IFRI/W16C02/00000416",
        "24/IFRI/W16C02/00000103",
        "21/IFRI/06/00010152",
        "22/IFRI/W09C02/00007553",
        "23/IFRI/W16C02/00000253",
        "24/IFRI/W16C02/00000118",
        "21/IFRI/03/00002577",
        "24/IFRI/W16C02/00000107",
        "22/IFRI/W16C02/00000039",
        "21/IFRI/06/00007789",
        "22/IFRI/W09C02/00008893",
        "22/IFRI/W09C02/00007615",
        "21/IFRI/06/00009870",
        "22/IFRI/W09C02/00013437",
        "22/IFRI/W16C02/00000798",
        "22/IFRI/W09C02/00008881",
        "21/IFRI/06/00007726",
        "21/IFRI/03/00001258",
        "22/IFRI/W16C02/00000981",
        "21/IFRI/03/00002645",
        "22/IFRI/W09C02/00004893",
        "21/IFRI/06/00010250",
        "24/IFRI/W16C02/00000233",
        "22/IFRI/W09C02/00008798",
        "21/IFRI/06/00007054",
        "24/IFRI/W16C02/00000288",
        "23/IFRI/W16C02/00000116",
        "24/IFRI/W16C02/00000205",
        "22/IFRI/W09C02/00008636",
        "22/IFRI/W09C02/00004899",
        "25/IFRI/W16C02/00000153",
        "21/IFRI/06/00007905",
        "22/IFRI/W09C02/00007373",
        "22/IFRI/W09C02/00011378",
        "24/IFRI/W16C02/00000286",
        "22/IFRI/W09C02/00007423",
        "22/IFRI/W09C02/00007377",
        "21/IFRI/03/00002581",
        "22/IFRI/W16C02/00001035",
        "21/IFRI/03/00001610",
        "21/IFRI/03/00001592",
        "24/IFRI/W16C02/00000036",
        "21/IFRI/03/00001578",
        "25/IFRI/W16C02/00000056",
        "23/IFRI/W16C02/00000133",
        "21/IFRI/03/00001286",
        "22/IFRI/W09C02/00010628",
        "22/IFRI/W16C02/00000640",
        "21/IFRI/03/00001502",
        "21/IFRI/06/00008245",
        "22/IFRI/W16C02/00000629",
        "22/IFRI/W09C02/00007381",
        "22/IFRI/W09C02/00006540",
        "22/IFRI/W16C02/00000399",
        "24/IFRI/W16C02/00000136",
        "22/IFRI/W09C02/00007352",
        "22/IFRI/W09C02/00004976",
        "21/IFRI/06/00009382",
        "22/IFRI/W16C02/00000543",
        "21/IFRI/03/00001248",
        "22/IFRI/W09C02/00010701",
        "22/IFRI/W09C02/00010574",
        "23/IFRI/W16C02/00000063",
        "21/IFRI/03/00001301",
        "22/IFRI/W16C02/00000553",
        "23/IFRI/W16C02/00000337",
        "21/IFRI/06/00010014",
        "23/IFRI/W16C02/00000348",
        "22/IFRI/W16C02/00000569",
        "22/IFRI/W09C02/00007372",
        "24/IFRI/W16C02/00000538",
        "21/IFRI/03/00001976",
        "25/IFRI/W16C02/00000166",
        "24/IFRI/W16C02/00000133",
        "23/IFRI/W16C02/00000314",
        "22/IFRI/W09C02/00007335",
        "22/IFRI/W09C02/00009823",
        "23/IFRI/W16C02/00000148",
        "24/IFRI/W16C02/00000137",
        "22/IFRI/W16C02/00000444",
        "22/IFRI/W16C02/00000662",
        "21/IFRI/03/00001316",
        "22/IFRI/W16C02/00000979",
        "21/IFRI/06/00007149",
        "24/IFRI/W16C02/00000547",
        "21/IFRI/03/00001935",
        "23/IFRI/W16C02/00000228",
        "25/IFRI/W16C02/00000093",
        "22/IFRI/W09C02/00006305",
        "25/IFRI/W16C02/00000022",
        "23/IFRI/W16C02/00000001",
        "21/IFRI/06/00010045",
        "22/IFRI/W16C02/00000689",
        "21/IFRI/06/00007095",
        "25/IFRI/W16C02/00000029",
        "22/IFRI/W09C02/00007394",
        "21/IFRI/06/00008193",
        "22/IFRI/W16C02/00000715",
        "22/IFRI/W16C02/00000452",
        "21/IFRI/03/00002354",
        "22/IFRI/W09C02/00007395",
        "22/IFRI/W16C02/00000425",
        "23/IFRI/W36C01/00004204",
        "22/IFRI/W09C02/00007346",
        "22/IFRI/W09C02/00008154",
        "21/IFRI/03/00002044",
        "24/IFRI/W16C02/00000320",
        "22/IFRI/W09C02/00007402",
        "22/IFRI/W16C02/00000493",
        "21/IFRI/03/00001784",
        "22/IFRI/W16C02/00001039",
        "23/IFRI/W16C02/00000353",
        "24/IFRI/W16C02/00000329",
        "25/IFRI/W16C02/00000144",
        "22/IFRI/W16C02/00000769",
        "21/IFRI/06/00007918",
        "22/IFRI/W09C02/00010618",
        "21/IFRI/03/00001799",
        "24/IFRI/W16C02/00000122",
        "24/IFRI/W16C02/00000154",
        "21/IFRI/03/00001599",
        "24/IFRI/W16C02/00000609",
        "22/IFRI/W09C02/00007584",
        "22/IFRI/W09C02/00007351",
        "21/IFRI/03/00001519",
        "24/IFRI/W16C02/00000040",
        "23/IFRI/W36C01/00004166",
        "25/IFRI/W16C02/00000132",
        "23/IFRI/W16C02/00000017",
        "21/IFRI/03/00002292",
        "23/IFRI/W16C02/00000297",
        "24/IFRI/W16C02/00000128",
        "25/IFRI/W16C02/00000076",
        "22/IFRI/W09C02/00007399",
        "21/IFRI/06/00008208",
        "23/IFRI/W16C02/00000216",
        "24/IFRI/W16C02/00000258",
        "22/IFRI/W16C02/00001012",
        "24/IFRI/W16C02/00000344",
        "23/IFRI/W16C02/00000334",
        "24/IFRI/W16C02/00000334",
        "25/IFRI/W16C02/00000158",
        "22/IFRI/W09C02/00010690",
        "22/IFRI/W09C02/00004898",
        "22/IFRI/W16C02/00000423",
        "22/IFRI/W16C02/00000411",
        "22/IFRI/W09C02/00007328",
        "21/IFRI/06/00010124",
        "25/IFRI/W16C02/00000154",
        "22/IFRI/W09C02/00007590",
        "21/IFRI/03/00002260",
        "25/IFRI/W16C02/00000124",
        "22/IFRI/W16C02/00000997",
        "24/IFRI/W16C02/00000204",
        "22/IFRI/W09C02/00008650",
        "25/IFRI/W16C02/00000091",
        "22/IFRI/W09C02/00009732",
        "21/IFRI/06/00007791",
        "23/IFRI/W16C02/00000257",
        "22/IFRI/W09C02/00007387",
        "22/IFRI/W09C02/00007317",
        "21/IFRI/03/00001949",
        "22/IFRI/W16C02/00000169",
        "22/IFRI/W09C02/00004167",
        "22/IFRI/W09C02/00006190",
        "22/IFRI/W16C02/00000948",
        "24/IFRI/W16C02/00000214",
        "22/IFRI/W16C02/00000676",
        "22/IFRI/W09C02/00007598",
        "22/IFRI/W09C02/00007599",
        "22/IFRI/W16C02/00000772",
        "22/IFRI/W09C02/00007537",
        "21/IFRI/06/00007727",
        "21/IFRI/06/00008194",
        "23/IFRI/W16C02/00000161",
        "24/IFRI/W16C02/00000024",
        "24/IFRI/W16C02/00000291",
        "22/IFRI/W09C02/00004989",
        "21/IFRI/06/00009320",
        "23/IFRI/W16C02/00000254",
        "23/IFRI/W16C02/00000158",
        "21/IFRI/03/00001225",
        "21/IFRI/03/00002310",
        "23/IFRI/W16C02/00000326",
        "25/IFRI/W16C02/00000157",
        "23/IFRI/W16C02/00000303",
        "23/IFRI/W16C02/00000298",
        "22/IFRI/W16C02/00000026",
        "21/IFRI/06/00007146",
        "25/IFRI/W16C02/00000087",
        "21/IFRI/03/00001263",
        "24/IFRI/W16C02/00000637",
        "22/IFRI/W09C02/00009780",
        "22/IFRI/W16C02/00000660",
        "22/IFRI/W09C02/00007326",
        "23/IFRI/W16C02/00000118",
        "24/IFRI/W16C02/00000289",
        "23/IFRI/W16C02/00000129",
        "21/IFRI/03/00002317",
        "24/IFRI/W16C02/00000090",
        "25/IFRI/W16C02/00000149",
        "23/IFRI/W16C02/00000021",
        "24/IFRI/W16C02/00000483",
        "21/IFRI/03/00001757",
        "23/IFRI/W16C02/00000217",
        "23/IFRI/W16C02/00000285",
        "21/IFRI/06/00010156",
        "24/IFRI/W16C02/00000376",
        "22/IFRI/W09C02/00004792",
        "24/IFRI/W16C02/00000179",
        "24/IFRI/W16C02/00000172",
        "23/IFRI/W16C02/00000238",
        "21/IFRI/03/00002689",
        "22/IFRI/W09C02/00004916",
        "22/IFRI/W09C02/00004865",
        "23/IFRI/W16C02/00000052",
        "23/IFRI/W16C02/00000356",
        "24/IFRI/W16C02/00000646",
        "22/IFRI/W09C02/00007426",
        "24/IFRI/W16C02/00000139",
        "22/IFRI/W09C02/00007349",
        "21/IFRI/03/00002708",
        "21/IFRI/03/00001609",
        "22/IFRI/W09C02/00004173",
        "22/IFRI/W09C02/00014266",
        "22/IFRI/W16C02/00000684",
        "21/IFRI/06/00010165",
        "24/IFRI/W16C02/00000263",
        "22/IFRI/W09C02/00007356",
        "24/IFRI/W16C02/00000264",
        "21/IFRI/06/00007924",
        "24/IFRI/W16C02/00000147",
        "24/IFRI/W16C02/00000332",
        "25/IFRI/W16C02/00000134",
        "22/IFRI/W16C02/00000171",
        "23/IFRI/W16C02/00000041",
        "22/IFRI/W09C02/00008903",
        "22/IFRI/W16C02/00000356",
        "22/IFRI/W09C02/00007808",
        "22/IFRI/W16C02/00000659",
        "22/IFRI/W09C02/00007676",
        "22/IFRI/W16C02/00000180",
        "22/IFRI/W09C02/00007809",
        "22/IFRI/W09C02/00007672",
        "22/IFRI/W09C02/00007645",
        "22/IFRI/W09C02/00007648",
        "21/IFRI/03/00001386",
        "23/IFRI/W16C02/00000027",
        "23/IFRI/W16C02/00000163",
        "23/IFRI/W16C02/00000164",
        "22/IFRI/W16C02/00001011",
        "25/IFRI/W16C02/00000100",
        "24/IFRI/W16C02/00000027",
        "25/IFRI/W16C02/00000048",
        "22/IFRI/06/00000280",
        "23/IFRI/03/00000082",
        "22/IFRI/W09C02/00012764",
        "21/IFRI/06/00002643",
        "23/IFRI/03/00000154",
        "23/IFRI/03/00000311",
        "24/IFRI/W16C02/00000463",
        "24/IFRI/03/00000348",
        "21/IFRI/06/00007648",
        "24/IFRI/03/00000330",
        "21/IFRI/06/00005327",
        "24/IFRI/03/00000107",
        "23/IFRI/03/00000356",
        "24/IFRI/03/00000039",
        "23/IFRI/03/00000301",
        "21/IFRI/06/00002741",
        "23/IFRI/03/00000507",
        "23/IFRI/03/00000067",
        "21/IFRI/06/00002757",
        "22/IFRI/W09C02/00010666",
        "21/IFRI/06/00005243",
        "23/IFRI/03/00000201",
        "21/IFRI/06/00002229",
        "23/IFRI/W09C02/00000092",
        "24/IFRI/03/00000011",
        "22/IFRI/06/00000149",
        "24/IFRI/03/00000379",
        "21/IFRI/03/00000197",
        "21/IFRI/06/00001087",
        "23/IFRI/03/00000446",
        "22/IFRI/W09C02/00012739",
        "21/IFRI/03/00000212",
        "24/IFRI/03/00000209",
        "21/IFRI/06/00005336",
        "23/IFRI/W36C01/00003760",
        "21/IFRI/03/00000301",
        "23/IFRI/03/00000157",
        "23/IFRI/03/00000078",
        "23/IFRI/W09C02/00000266",
        "24/IFRI/03/00000186",
        "25/IFRI/03/00000013",
        "21/IFRI/03/00000137",
        "21/IFRI/03/00004972",
        "21/IFRI/06/00003652",
        "24/IFRI/03/00000111",
        "21/IFRI/06/00001195",
        "24/IFRI/03/00000020",
        "23/IFRI/03/00000292",
        "21/IFRI/06/00001154",
        "21/IFRI/06/00002666",
        "23/IFRI/03/00000109",
        "23/IFRI/03/00000267",
        "24/IFRI/03/00000029",
        "23/IFRI/03/00000453",
        "21/IFRI/06/00000388",
        "21/IFRI/06/00001451",
        "24/IFRI/03/00000334",
        "21/IFRI/06/00001007",
        "25/IFRI/03/00000029",
        "23/IFRI/03/00000360",
        "23/IFRI/03/00000367",
        "25/IFRI/03/00000035",
        "22/IFRI/03/00000096",
        "23/IFRI/03/00000079",
        "24/IFRI/03/00000102",
        "21/IFRI/03/00005069",
        "22/IFRI/06/00000285",
        "22/IFRI/W09C02/00012762",
        "21/IFRI/06/00006357",
        "21/IFRI/06/00001095",
        "22/IFRI/03/00000113",
        "23/IFRI/03/00000474",
        "22/IFRI/03/00000124",
        "23/IFRI/03/00000117",
        "24/IFRI/03/00000021",
        "24/IFRI/03/00000080",
        "21/IFRI/06/00002200",
        "22/IFRI/W09C02/00012756",
        "21/IFRI/03/00005119",
        "24/IFRI/03/00000116",
        "24/IFRI/03/00000062",
        "21/IFRI/03/00005121",
        "21/IFRI/06/00005407",
        "23/IFRI/03/00000151",
        "23/IFRI/03/00000350",
        "21/IFRI/03/00000426",
        "24/IFRI/03/00000149",
        "22/IFRI/W09C02/00010672",
        "25/IFRI/03/00000012",
        "21/IFRI/03/00005079",
        "24/IFRI/W36C01/00003354",
        "24/IFRI/W36C01/00003131",
        "25/IFRI/03/00000039",
        "23/IFRI/03/00000203",
        "24/IFRI/03/00000046",
        "21/IFRI/06/00007191",
        "23/IFRI/03/00000359",
        "22/IFRI/06/00000105",
        "25/IFRI/W16C02/00000071",
        "23/IFRI/03/00000159",
        "21/IFRI/03/00005098",
        "23/IFRI/03/00000480",
        "22/IFRI/W09C02/00004033",
        "23/IFRI/03/00000090",
        "22/IFRI/03/00000059",
        "24/IFRI/03/00000133",
        "24/IFRI/03/00000143",
        "22/IFRI/W09C02/00004850",
        "22/IFRI/03/00000097",
        "22/IFRI/W09C02/00011436",
        "23/IFRI/03/00000087",
        "22/IFRI/03/00000130",
        "24/IFRI/03/00000034",
        "21/IFRI/03/00000273",
        "22/IFRI/W09C02/00004769",
        "21/IFRI/06/00003551",
        "24/IFRI/03/00000099",
        "21/IFRI/06/00001210",
        "23/IFRI/03/00000347",
        "467_1749031415161",
        "21/IFRI/03/00005052",
        "22/IFRI/W09C02/00012760",
        "24/IFRI/03/00000242",
        "467_1749031415224",
        "23/IFRI/03/00000001",
        "21/IFRI/06/00006638",
        "22/IFRI/03/00000066",
        "24/IFRI/W36C01/00000525",
        "21/IFRI/06/00002526",
        "23/IFRI/W09C02/00000077",
        "21/IFRI/03/00000080",
        "22/IFRI/W09C02/00012853",
        "22/IFRI/06/00000098",
        "23/IFRI/03/00000134",
        "24/IFRI/W16C02/00000569",
        "23/IFRI/03/00000230",
        "23/IFRI/03/00000389",
        "23/IFRI/03/00000491",
        "24/IFRI/03/00000286",
        "22/IFRI/W09C02/00014020",
        "23/IFRI/03/00000487",
        "21/IFRI/06/00005300",
        "24/IFRI/03/00000287",
        "21/IFRI/06/00007981",
        "21/IFRI/06/00003495",
        "21/IFRI/06/00002195",
        "22/IFRI/W09C02/00004827",
        "22/IFRI/W09C02/00006787",
        "21/IFRI/03/00004729",
        "23/IFRI/03/00000035",
        "21/IFRI/03/00000390",
        "25/IFRI/03/00000009",
        "22/IFRI/06/00000269",
        "21/IFRI/06/00002545",
        "21/IFRI/03/00004909",
        "21/IFRI/06/00005610",
        "24/IFRI/03/00000087",
        "22/IFRI/W09C02/00004012",
        "21/IFRI/06/00005472",
        "22/IFRI/06/00000157",
        "22/IFRI/W09C02/00013194",
        "21/IFRI/06/00003398",
        "23/IFRI/03/00000455",
        "24/IFRI/03/00000012",
        "21/IFRI/03/00005007",
        "24/IFRI/03/00000179",
        "21/IFRI/03/00000255",
        "23/IFRI/03/00000338",
        "25/IFRI/03/00000038",
        "467_1747566130792",
        "21/IFRI/03/00004933",
        "25/IFRI/03/00000030",
        "23/IFRI/03/00000218",
        "25/IFRI/03/00000003",
        "21/IFRI/03/00005013",
        "24/IFRI/03/00000288",
        "23/IFRI/03/00000362",
        "21/IFRI/06/00002669",
        "21/IFRI/06/00001008",
        "23/IFRI/03/00000237",
        "24/IFRI/03/00000328",
        "22/IFRI/W09C02/00009719",
        "22/IFRI/W09C02/00011444",
        "22/IFRI/W09C02/00011435",
        "24/IFRI/03/00000223",
        "24/IFRI/03/00000108",
        "23/IFRI/03/00000282",
        "21/IFRI/06/00006751",
        "21/IFRI/06/00003461",
        "22/IFRI/W09C02/00009816",
        "21/IFRI/06/00002649",
        "24/IFRI/03/00000032",
        "24/IFRI/03/00000371",
        "22/IFRI/06/00000100",
        "21/IFRI/06/00002602",
        "22/IFRI/W09C02/00014069",
        "25/IFRI/03/00000008",
        "22/IFRI/W09C02/00012860",
        "21/IFRI/03/00005073",
        "21/IFRI/06/00001609",
        "21/IFRI/06/00002679",
        "23/IFRI/03/00000130",
        "21/IFRI/06/00001121",
        "22/IFRI/W09C02/00004824",
        "21/IFRI/06/00002650",
        "25/IFRI/03/00000010",
        "24/IFRI/W16C02/00000341",
        "23/IFRI/03/00000337",
        "25/IFRI/03/00000036",
        "22/IFRI/W09C02/00004853",
        "24/IFRI/03/00000018",
        "22/IFRI/03/00000127",
        "21/IFRI/06/00003216",
        "21/IFRI/03/00004832",
        "24/IFRI/03/00000035",
        "21/IFRI/06/00002726",
        "24/IFRI/03/00000289",
        "21/IFRI/06/00003350",
        "24/IFRI/03/00000106",
        "22/IFRI/W09C02/00012654",
        "21/IFRI/06/00002604",
        "21/IFRI/06/00008044",
        "23/IFRI/03/00000170",
        "21/IFRI/03/00004823",
        "21/IFRI/06/00001477",
        "22/IFRI/06/00000032",
        "23/IFRI/03/00000280",
        "22/IFRI/W09C02/00010695",
        "23/IFRI/03/00000005",
        "22/IFRI/03/00000132",
        "22/IFRI/W09C02/00013248",
        "23/IFRI/03/00000248",
        "23/IFRI/03/00000482",
        "21/IFRI/03/00000292",
        "24/IFRI/03/00000114",
        "21/IFRI/06/00006640",
        "24/IFRI/03/00000077",
        "23/IFRI/03/00000143",
        "24/IFRI/03/00000327",
        "24/IFRI/03/00000363",
        "24/IFRI/03/00000109",
        "22/IFRI/W09C02/00006724",
        "22/IFRI/W09C02/00005946",
        "21/IFRI/06/00015619",
        "23/IFRI/03/00000013",
        "22/IFRI/06/00000035",
        "21/IFRI/03/00005075",
        "23/IFRI/03/00000460",
        "24/IFRI/03/00000113",
        "23/IFRI/03/00000167",
        "22/IFRI/W09C02/00004609",
        "25/IFRI/03/00000040",
        "25/IFRI/03/00000028",
        "21/IFRI/06/00006637",
        "24/IFRI/03/00000365",
        "23/IFRI/03/00000300",
        "22/IFRI/06/00000065",
        "24/IFRI/W16C01/00000396",
        "21/IFRI/06/00007231",
        "23/IFRI/W16C04/00002010",
        "23/IFRI/W16C04/00001700",
        "22/IFRI/W16C04/00000491",
        "23/IFRI/W16C04/00001415",
        "23/IFRI/W16C04/00002456",
        "23/IFRI/W16C04/00000494",
        "23/IFRI/W16C04/00003144",
        "23/IFRI/W16C04/00003312",
        "23/IFRI/W16C04/00000661",
        "24/IFRI/W16C04/00000563",
        "23/IFRI/W16C04/00000444",
        "25/IFRI/W16C04/00000029",
        "25/IFRI/W16C04/00000428",
        "24/IFRI/W16C04/00000263",
        "25/IFRI/W16C04/00000397",
        "23/IFRI/W16C04/00003049",
        "22/IFRI/W16C04/00003916",
        "24/IFRI/W16C04/00000089",
        "22/IFRI/W16C04/00003595",
        "24/IFRI/W16C04/00000122",
        "23/IFRI/W16C04/00002784",
        "23/IFRI/W16C04/00001133",
        "23/IFRI/W16C04/00000694",
        "23/IFRI/W16C04/00002847",
        "25/IFRI/W16C04/00000042",
        "22/IFRI/W16C04/00003897",
        "24/IFRI/W16C04/00000267",
        "22/IFRI/W16C04/00000886",
        "23/IFRI/W16C04/00001194",
        "24/IFRI/W16C04/00000739",
        "25/IFRI/W16C04/00000051",
        "23/IFRI/W16C04/00002661",
        "23/IFRI/W16C04/00001658",
        "22/IFRI/W16C04/00003765",
        "23/IFRI/W16C04/00000787",
        "23/IFRI/W16C04/00001309",
        "23/IFRI/W16C04/00003043",
        "23/IFRI/W16C04/00002147",
        "25/IFRI/W16C04/00000304",
        "23/IFRI/W16C04/00003353",
        "25/IFRI/W16C04/00000091",
        "24/IFRI/W16C04/00000046",
        "25/IFRI/W16C04/00000095",
        "23/IFRI/W16C04/00001335",
        "23/IFRI/W09C02/00000107",
        "25/IFRI/W16C04/00000444",
        "23/IFRI/W16C04/00002023",
        "22/IFRI/W16C04/00004545",
        "25/IFRI/W16C04/00000052",
        "23/IFRI/W16C04/00000093",
        "23/IFRI/W16C04/00003385",
        "25/IFRI/W16C04/00000213",
        "23/IFRI/W16C04/00002995",
        "23/IFRI/W16C04/00003469",
        "23/IFRI/W16C04/00003180",
        "23/IFRI/W16C04/00003386",
        "25/IFRI/W16C04/00000422",
        "25/IFRI/W16C04/00000459",
        "23/IFRI/W16C04/00000069",
        "22/IFRI/W16C04/00003723",
        "22/IFRI/W09C02/00013361",
        "23/IFRI/W16C04/00003392",
        "23/IFRI/W09C02/00000131",
        "24/IFRI/W16C04/00000740",
        "23/IFRI/W16C04/00000666",
        "22/IFRI/W16C04/00004050",
        "25/IFRI/W16C04/00000228",
        "25/IFRI/W16C04/00000107",
        "25/IFRI/W16C04/00000371",
        "23/IFRI/W16C04/00002554",
        "23/IFRI/W16C04/00002480",
        "25/IFRI/W16C04/00000056",
        "23/IFRI/W16C04/00001490",
        "23/IFRI/W16C04/00003054",
        "23/IFRI/W16C04/00002057",
        "24/IFRI/W16C04/00000184",
        "23/IFRI/W16C04/00002844",
        "24/IFRI/W16C04/00000510",
        "24/IFRI/W16C04/00000206",
        "23/IFRI/W16C04/00003431",
        "23/IFRI/W09C02/00000143",
        "23/IFRI/W09C02/00000144",
        "23/IFRI/W16C04/00002758",
        "24/IFRI/W16C04/00000052",
        "23/IFRI/W16C04/00001144",
        "23/IFRI/W16C04/00002613",
        "23/IFRI/W16C04/00001880",
        "23/IFRI/W16C04/00000261",
        "22/IFRI/W16C04/00003657",
        "23/IFRI/W16C04/00003088",
        "24/IFRI/W16C04/00000346",
        "23/IFRI/W16C04/00000488",
        "25/IFRI/W16C04/00000395",
        "23/IFRI/W16C04/00000125",
        "23/IFRI/W16C04/00003403",
        "22/IFRI/W16C04/00004549",
        "22/IFRI/W16C04/00003792",
        "22/IFRI/W16C04/00004576",
        "23/IFRI/W16C04/00003038",
        "25/IFRI/W16C04/00000145",
        "23/IFRI/W16C04/00002865",
        "22/IFRI/W16C04/00003672",
        "23/IFRI/W16C04/00003279",
        "25/IFRI/W16C04/00000028",
        "24/IFRI/W16C04/00000081",
        "22/IFRI/W16C04/00003822",
        "23/IFRI/W16C04/00003436",
        "23/IFRI/W16C04/00000476",
        "23/IFRI/W16C04/00001673",
        "22/IFRI/W16C04/00003865",
        "23/IFRI/W16C04/00002040",
        "23/IFRI/W16C04/00001292",
        "22/IFRI/W16C04/00003670",
        "23/IFRI/W16C04/00000735",
        "23/IFRI/W16C04/00001358",
        "23/IFRI/W16C04/00002887",
        "25/IFRI/W16C04/00000358",
        "23/IFRI/W16C04/00002867",
        "25/IFRI/W16C04/00000369",
        "23/IFRI/W16C04/00000648",
        "23/IFRI/W16C04/00000780",
        "23/IFRI/W16C04/00003278",
        "23/IFRI/W16C04/00000788",
        "23/IFRI/W16C04/00001258",
        "25/IFRI/W16C04/00000203",
        "23/IFRI/W16C04/00002136",
        "23/IFRI/W16C04/00000379",
        "23/IFRI/W16C04/00003450",
        "23/IFRI/W16C04/00002852",
        "23/IFRI/W16C04/00001142",
        "24/IFRI/W16C04/00000098",
        "23/IFRI/W16C04/00001363",
        "23/IFRI/W16C04/00000398",
        "23/IFRI/W16C04/00003093",
        "22/IFRI/W16C04/00003999",
        "23/IFRI/W16C04/00000423",
        "23/IFRI/W16C04/00002144",
        "23/IFRI/W16C04/00002481",
        "23/IFRI/W16C04/00002069",
        "22/IFRI/W16C04/00004632",
        "23/IFRI/W16C04/00003373",
        "23/IFRI/W16C04/00000821",
        "25/IFRI/W16C04/00000075",
        "23/IFRI/W16C04/00001368",
        "23/IFRI/W16C04/00000831",
        "23/IFRI/W16C04/00001134",
        "25/IFRI/W16C04/00000049",
        "23/IFRI/W16C04/00000836",
        "24/IFRI/W16C04/00000280",
        "23/IFRI/W16C04/00000843",
        "24/IFRI/W16C04/00000031",
        "24/IFRI/W16C04/00000207",
        "23/IFRI/W16C04/00002385",
        "25/IFRI/W16C04/00000407",
        "23/IFRI/W16C04/00000853",
        "23/IFRI/W36C01/00003756",
        "22/IFRI/W16C04/00003786",
        "23/IFRI/W16C04/00002846",
        "25/IFRI/W16C04/00000030",
        "23/IFRI/W16C04/00003322",
        "24/IFRI/W16C04/00000746",
        "25/IFRI/W16C04/00000253",
        "23/IFRI/W16C04/00002600",
        "25/IFRI/W16C04/00000211",
        "23/IFRI/W16C04/00000884",
        "23/IFRI/W16C04/00000043",
        "23/IFRI/W16C04/00002406",
        "24/IFRI/W16C04/00000312",
        "23/IFRI/W16C04/00000750",
        "23/IFRI/W16C04/00002628",
        "23/IFRI/W16C04/00000296",
        "25/IFRI/W16C04/00000129",
        "24/IFRI/W16C04/00000078",
        "23/IFRI/W16C04/00000523",
        "24/IFRI/W16C04/00000324",
        "25/IFRI/W16C04/00000264",
        "23/IFRI/W16C04/00000902",
        "23/IFRI/W16C04/00003461",
        "23/IFRI/W16C04/00002432",
        "23/IFRI/W16C04/00001509",
        "23/IFRI/W16C04/00003202",
        "23/IFRI/W09C02/00000138",
        "23/IFRI/W16C04/00002938",
        "23/IFRI/W16C04/00003045",
        "23/IFRI/W16C04/00000340",
        "24/IFRI/W16C04/00000208",
        "23/IFRI/W16C04/00000639",
        "25/IFRI/W16C04/00000273",
        "23/IFRI/W16C04/00000689",
        "24/IFRI/W16C04/00000127",
        "23/IFRI/W16C04/00001294",
        "23/IFRI/W16C04/00002940",
        "24/IFRI/W16C04/00000214",
        "23/IFRI/W16C04/00003345",
        "23/IFRI/W16C04/00002336",
        "25/IFRI/W16C04/00000318",
        "23/IFRI/W16C04/00001209",
        "25/IFRI/W16C04/00000336",
        "23/IFRI/W16C04/00001262",
        "22/IFRI/W16C04/00003698",
        "22/IFRI/W16C04/00003793",
        "24/IFRI/W16C04/00000259",
        "23/IFRI/W16C04/00000771",
        "23/IFRI/W16C04/00000004",
        "23/IFRI/W16C04/00000957",
        "23/IFRI/W16C04/00002990",
        "24/IFRI/W16C04/00000256",
        "23/IFRI/W16C04/00000962",
        "25/IFRI/W16C04/00000417",
        "23/IFRI/W16C04/00002959",
        "23/IFRI/W16C04/00003074",
        "23/IFRI/W16C04/00000472",
        "23/IFRI/W16C04/00003181",
        "24/IFRI/W16C04/00000220",
        "25/IFRI/W16C04/00000050",
        "23/IFRI/W16C04/00003476",
        "23/IFRI/W16C04/00003146",
        "23/IFRI/W16C04/00003004",
        "24/IFRI/W16C04/00000009",
        "24/IFRI/W16C04/00000062",
        "25/IFRI/W16C04/00000321",
        "23/IFRI/W16C04/00000435",
        "25/IFRI/W16C04/00000280",
        "23/IFRI/W16C04/00003388",
        "25/IFRI/W16C04/00000054",
        "25/IFRI/W16C04/00000364",
        "23/IFRI/W16C04/00002902",
        "24/IFRI/W16C04/00000185",
        "23/IFRI/W16C04/00002970",
        "25/IFRI/W16C04/00000400",
        "23/IFRI/W16C04/00002146",
        "23/IFRI/W16C04/00003090",
        "25/IFRI/W16C04/00000265",
        "23/IFRI/W16C04/00003167",
        "23/IFRI/W16C04/00000998",
        "24/IFRI/W16C04/00000196",
        "1608_1749472227502",
        "23/IFRI/W16C04/00000995",
        "23/IFRI/W16C04/00002374",
        "22/IFRI/W16C04/00003804",
        "25/IFRI/W16C04/00000173",
        "23/IFRI/W16C04/00002967",
        "23/IFRI/W16C04/00001695",
        "24/IFRI/W16C04/00000049",
        "23/IFRI/W16C04/00002080",
        "23/IFRI/W16C04/00001957",
        "23/IFRI/W16C04/00003282",
        "25/IFRI/W16C04/00000362",
        "23/IFRI/W16C04/00000875",
        "23/IFRI/W16C04/00001973",
        "23/IFRI/W16C04/00000560",
        "24/IFRI/W16C04/00000756",
        "24/IFRI/W16C04/00000647",
        "23/IFRI/W16C04/00000460",
        "23/IFRI/W16C04/00001843",
        "25/IFRI/W16C04/00000405",
        "23/IFRI/W16C04/00002723",
        "22/IFRI/W16C04/00004438",
        "24/IFRI/W16C04/00000699",
        "22/IFRI/W16C04/00003818",
        "23/IFRI/W16C04/00002319",
        "23/IFRI/W16C04/00003285",
        "24/IFRI/W16C04/00000338",
        "23/IFRI/W16C04/00002688",
        "24/IFRI/W16C04/00000484",
        "23/IFRI/W16C04/00003395",
        "23/IFRI/W16C04/00001389",
        "23/IFRI/W16C04/00002855",
        "24/IFRI/W16C04/00000404",
        "24/IFRI/W16C04/00000087",
        "23/IFRI/W16C04/00000938",
        "23/IFRI/W16C04/00001229",
        "24/IFRI/W16C04/00000209",
        "25/IFRI/W16C04/00000317",
        "24/IFRI/W16C04/00000175",
        "23/IFRI/W16C04/00000703",
        "24/IFRI/W16C04/00000252",
        "24/IFRI/W16C04/00000069",
        "24/IFRI/W16C04/00000187",
        "23/IFRI/W16C04/00000115",
        "23/IFRI/W16C04/00001603",
        "23/IFRI/W16C04/00002860",
        "24/IFRI/W16C04/00000789",
        "23/IFRI/W16C04/00001010",
        "23/IFRI/W16C04/00001273",
        "23/IFRI/W16C04/00001013",
        "22/IFRI/W16C04/00004167",
        "23/IFRI/W16C04/00000575",
        "24/IFRI/W16C04/00000714",
        "23/IFRI/W16C04/00000594",
        "23/IFRI/W16C04/00000855",
        "23/IFRI/W16C04/00002287",
        "24/IFRI/W16C04/00000091",
        "24/IFRI/W16C04/00000695",
        "24/IFRI/W16C04/00000485",
        "25/IFRI/W16C04/00000426",
        "24/IFRI/W16C04/00000781",
        "2362_1748942841403",
        "23/IFRI/W16C04/00000428",
        "24/IFRI/W16C04/00000791",
        "25/IFRI/W16C04/00000419",
        "23/IFRI/W16C04/00002074",
        "23/IFRI/W16C04/00001800",
        "23/IFRI/W16C04/00002313",
        "24/IFRI/W16C04/00000790",
        "24/IFRI/W16C04/00000805",
        "23/IFRI/W16C04/00002705",
        "25/IFRI/W16C04/00000415",
        "23/IFRI/W16C04/00003255",
        "25/IFRI/W16C04/00000408",
        "24/IFRI/W16C04/00000210",
        "23/IFRI/W16C04/00000614",
        "1608_1748531994700",
        "23/IFRI/W16C04/00002999",
        "24/IFRI/W16C04/00000797",
        "23/IFRI/W16C04/00003384",
        "24/IFRI/W16C04/00000234",
        "24/IFRI/W16C04/00000751",
        "23/IFRI/W16C04/00003267",
        "24/IFRI/W16C04/00000211",
        "22/IFRI/W16C04/00004573",
        "23/IFRI/W16C04/00000175",
        "25/IFRI/W16C04/00000315",
        "22/IFRI/W16C04/00003768",
        "24/IFRI/W16C04/00000233",
        "23/IFRI/W16C04/00000608",
        "23/IFRI/W16C04/00000606",
        "23/IFRI/W16C04/00000482",
        "23/IFRI/W16C04/00003063",
        "22/IFRI/W16C04/00004028",
        "22/IFRI/W16C04/00003612",
        "25/IFRI/W16C04/00000441",
        "23/IFRI/W16C04/00002382",
        "25/IFRI/W16C04/00000175",
        "23/IFRI/W16C04/00000603",
        "24/IFRI/W16C04/00000360",
        "23/IFRI/W16C04/00001405",
        "23/IFRI/W16C04/00003387",
        "23/IFRI/W16C04/00001032",
        "25/IFRI/W16C04/00000221",
        "23/IFRI/W16C04/00001034",
        "23/IFRI/W16C04/00000626",
        "25/IFRI/W16C04/00000330",
        "25/IFRI/W16C04/00000343",
        "23/IFRI/W16C04/00001230",
        "23/IFRI/W16C04/00001851",
        "25/IFRI/W16C04/00000412",
        "23/IFRI/W16C04/00003474",
        "25/IFRI/W16C04/00000344",
        "22/IFRI/W16C04/00003872",
        "24/IFRI/W16C04/00000652",
        "24/IFRI/W16C04/00000241",
        "22/IFRI/W16C04/00003870",
        "24/IFRI/W16C04/00000095",
        "23/IFRI/W16C04/00003169",
        "24/IFRI/W16C04/00000251",
        "25/IFRI/W16C04/00000001",
        "23/IFRI/W16C04/00001317",
        "23/IFRI/W16C04/00001060",
        "23/IFRI/W16C04/00002851",
        "23/IFRI/W16C04/00002048",
        "22/IFRI/W16C04/00004103",
        "23/IFRI/W16C04/00002062",
        "24/IFRI/W16C04/00000242",
        "23/IFRI/W16C04/00003472",
        "23/IFRI/W16C04/00002837",
        "23/IFRI/W16C04/00001546",
        "25/IFRI/W16C04/00000014",
        "23/IFRI/W16C04/00001364",
        "23/IFRI/W16C04/00001929",
        "23/IFRI/W16C04/00000820",
        "23/IFRI/W16C04/00001272",
        "25/IFRI/W16C04/00000442",
        "23/IFRI/W16C04/00001930",
        "22/IFRI/W16C04/00003962",
        "24/IFRI/W16C04/00000260",
        "23/IFRI/W16C04/00001547",
        "23/IFRI/W16C04/00003396",
        "23/IFRI/W16C04/00002400",
        "23/IFRI/W16C04/00002718",
        "23/IFRI/W16C04/00003252",
        "22/IFRI/W16C04/00004465",
        "25/IFRI/W16C04/00000406",
        "23/IFRI/W16C04/00001653",
        "23/IFRI/W16C04/00002858",
        "24/IFRI/W16C04/00000143",
        "23/IFRI/W16C04/00001075",
        "23/IFRI/W36C01/00004200",
        "24/IFRI/W16C04/00000511",
        "23/IFRI/W16C04/00001253",
        "24/IFRI/W16C04/00000741",
        "23/IFRI/W16C04/00001078",
        "25/IFRI/W16C04/00000359",
        "23/IFRI/W16C04/00003171",
        "25/IFRI/W16C04/00000418",
        "23/IFRI/W16C04/00002769",
        "24/IFRI/W16C04/00000140",
        "24/IFRI/W16C04/00000710",
        "23/IFRI/W16C04/00000405",
        "24/IFRI/W16C04/00000353",
        "23/IFRI/W16C04/00001714",
        "23/IFRI/W16C04/00003460",
        "25/IFRI/W16C04/00000232",
        "23/IFRI/W16C04/00000720",
        "25/IFRI/W16C04/00000309",
        "23/IFRI/W16C04/00002992",
        "23/IFRI/W16C04/00000479",
        "22/IFRI/W16C04/00004150",
        "23/IFRI/W16C04/00003271",
        "23/IFRI/W16C04/00000457",
        "23/IFRI/W16C04/00002685",
        "23/IFRI/W16C04/00001235",
        "23/IFRI/W16C04/00003047",
        "24/IFRI/W36C01/00000036",
        "23/IFRI/W16C04/00002737",
        "25/IFRI/W16C04/00000135",
        "23/IFRI/W16C04/00003349",
        "23/IFRI/W16C04/00002142",
        "23/IFRI/W16C04/00003166",
        "23/IFRI/W16C04/00000008",
        "24/IFRI/W16C04/00000648",
        "24/IFRI/W16C04/00000649",
        "25/IFRI/W16C04/00000046",
        "23/IFRI/W16C04/00000743",
        "23/IFRI/W16C04/00001238",
        "23/IFRI/W16C04/00003346",
        "24/IFRI/W16C04/00000224",
        "25/IFRI/W16C04/00000177",
        "23/IFRI/W16C04/00002692",
        "23/IFRI/W16C04/00002878",
        "23/IFRI/W16C04/00002003",
        "23/IFRI/W16C04/00002028",
        "22/IFRI/W16C04/00004625",
        "24/IFRI/W16C04/00000194",
        "23/IFRI/W16C04/00000218",
        "24/IFRI/W16C04/00000328",
        "22/IFRI/W16C04/00003937",
        "23/IFRI/W16C04/00000709",
        "24/IFRI/W16C04/00000333",
        "22/IFRI/W16C04/00004568",
        "23/IFRI/W16C04/00000107",
        "23/IFRI/W16C04/00000417",
        "25/IFRI/W16C04/00000384",
        "23/IFRI/W16C04/00000370",
        "23/IFRI/W16C04/00002874",
        "25/IFRI/W16C04/00000398",
        "22/IFRI/W16C04/00004036",
        "24/IFRI/W16C04/00000322",
        "22/IFRI/W16C04/00004172",
        "22/IFRI/W16C04/00003944",
        "23/IFRI/W16C04/00000643",
        "23/IFRI/W16C04/00001091",
        "22/IFRI/W16C04/00003846",
        "25/IFRI/W16C04/00000045",
        "23/IFRI/W16C04/00001240",
        "25/IFRI/W16C04/00000015",
        "23/IFRI/W16C04/00002446",
        "23/IFRI/W16C04/00001558",
        "24/IFRI/W16C04/00000737",
        "23/IFRI/W16C04/00003184",
        "23/IFRI/W16C04/00003417",
        "22/IFRI/W16C04/00000781",
        "23/IFRI/W16C04/00002295",
        "22/IFRI/W16C04/00004495",
        "23/IFRI/W16C04/00003042",
        "22/IFRI/W16C04/00004064",
        "23/IFRI/W16C04/00003083",
        "22/IFRI/W16C04/00000785",
        "24/IFRI/W16C04/00000218",
        "22/IFRI/W16C04/00004289",
        "1569_1748508688502",
        "23/IFRI/W16C04/00000484",
        "22/IFRI/W16C04/00004008",
        "23/IFRI/W16C04/00000474",
        "22/IFRI/W16C04/00003888",
        "23/IFRI/W16C04/00001726",
        "22/IFRI/W09C02/00009905",
        "22/IFRI/W09C02/00011569",
        "23/IFRI/W16C01/00000189",
        "22/IFRI/W09C02/00012752",
        "22/IFRI/W09C02/00011947",
        "22/IFRI/W16C01/00000273",
        "22/IFRI/W09C02/00010093",
        "23/IFRI/W16C01/00000121",
        "22/IFRI/W16C01/00000161",
        "22/IFRI/W09C02/00010125",
        "22/IFRI/W09C02/00011489",
        "22/IFRI/W09C02/00011347",
        "22/IFRI/W09C02/00010161",
        "23/IFRI/W16C01/00000161",
        "22/IFRI/W16C01/00000470",
        "22/IFRI/W16C01/00001089",
        "23/IFRI/W16C01/00000038",
        "2589_1749726023713",
        "22/IFRI/W16C01/00000255",
        "22/IFRI/W09C02/00010143",
        "24/IFRI/W16C01/00000307",
        "22/IFRI/W16C01/00000305",
        "23/IFRI/W16C01/00000433",
        "24/IFRI/W16C01/00000095",
        "23/IFRI/W16C01/00000081",
        "25/IFRI/W16C01/00000222",
        "24/IFRI/W16C01/00000355",
        "24/IFRI/W16C01/00000138",
        "22/IFRI/W16C01/00000425",
        "24/IFRI/W16C01/00000251",
        "22/IFRI/W09C02/00011466",
        "22/IFRI/W16C01/00000588",
        "22/IFRI/W09C02/00009875",
        "22/IFRI/W09C02/00010375",
        "24/IFRI/W16C01/00000264",
        "22/IFRI/W09C02/00014035",
        "22/IFRI/W09C02/00011590",
        "24/IFRI/W16C01/00000359",
        "25/IFRI/W16C01/00000139",
        "22/IFRI/W09C02/00011976",
        "22/IFRI/W09C02/00010171",
        "23/IFRI/W16C01/00000508",
        "23/IFRI/W16C01/00000132",
        "22/IFRI/W09C02/00011140",
        "22/IFRI/W09C02/00010552",
        "24/IFRI/W16C01/00000111",
        "23/IFRI/W16C01/00000601",
        "23/IFRI/W16C01/00000055",
        "22/IFRI/W16C01/00001006",
        "22/IFRI/W09C02/00010747",
        "24/IFRI/W16C01/00000101",
        "22/IFRI/W16C01/00000659",
        "23/IFRI/W16C01/00000527",
        "23/IFRI/W16C01/00000602",
        "23/IFRI/W16C01/00000083",
        "22/IFRI/W16C01/00000590",
        "22/IFRI/W16C01/00000539",
        "24/IFRI/W16C01/00000234",
        "24/IFRI/W16C01/00000235",
        "22/IFRI/W09C02/00013652",
        "25/IFRI/W16C01/00000035",
        "23/IFRI/W16C01/00000509",
        "22/IFRI/W16C01/00001297",
        "22/IFRI/W16C01/00000646",
        "24/IFRI/W16C01/00000280",
        "24/IFRI/W16C01/00000388",
        "23/IFRI/W09C02/00000016",
        "22/IFRI/W09C02/00010749",
        "23/IFRI/W16C01/00000243",
        "24/IFRI/W16C01/00000067",
        "23/IFRI/W16C01/00000474",
        "22/IFRI/W09C02/00013681",
        "23/IFRI/W09C02/00000274",
        "23/IFRI/W09C02/00000721",
        "22/IFRI/W09C02/00011109",
        "22/IFRI/W09C02/00010554",
        "22/IFRI/W09C02/00011344",
        "23/IFRI/W16C01/00000523",
        "23/IFRI/W09C02/00000028",
        "22/IFRI/W09C02/00009852",
        "22/IFRI/W16C01/00001108",
        "24/IFRI/W16C01/00000374",
        "22/IFRI/W09C02/00011581",
        "22/IFRI/W09C02/00009887",
        "22/IFRI/W09C02/00013680",
        "22/IFRI/W09C02/00013629",
        "23/IFRI/W16C01/00000475",
        "22/IFRI/W09C02/00011841",
        "22/IFRI/W09C02/00011189",
        "22/IFRI/W09C02/00014169",
        "23/IFRI/W09C02/00000297",
        "22/IFRI/W09C02/00009845",
        "22/IFRI/W09C02/00011131",
        "23/IFRI/W16C01/00000065",
        "22/IFRI/W09C02/00011527",
        "22/IFRI/W09C02/00010294",
        "22/IFRI/W09C02/00012722",
        "23/IFRI/W16C01/00000133",
        "24/IFRI/W16C01/00000365",
        "23/IFRI/W16C01/00000434",
        "22/IFRI/W16C01/00001303",
        "25/IFRI/W16C01/00000092",
        "22/IFRI/W16C01/00000272",
        "22/IFRI/W16C01/00000437",
        "22/IFRI/W09C02/00009956",
        "22/IFRI/W16C01/00000400",
        "24/IFRI/W16C01/00000150",
        "25/IFRI/W16C01/00000104",
        "22/IFRI/W09C02/00009876",
        "22/IFRI/W09C02/00011470",
        "22/IFRI/W09C02/00014226",
        "22/IFRI/W09C02/00009991",
        "22/IFRI/W09C02/00014050",
        "22/IFRI/W09C02/00009978",
        "22/IFRI/W16C01/00001364",
        "22/IFRI/W16C01/00000699",
        "25/IFRI/W16C01/00000096",
        "23/IFRI/W09C02/00000292",
        "22/IFRI/W16C01/00000585",
        "22/IFRI/W09C02/00010203",
        "22/IFRI/W16C01/00000592",
        "23/IFRI/W16C01/00000604",
        "22/IFRI/W16C01/00000548",
        "22/IFRI/W16C01/00001333",
        "22/IFRI/W09C02/00010230",
        "24/IFRI/W16C01/00000256",
        "23/IFRI/W16C01/00000560",
        "23/IFRI/W16C01/00000315",
        "23/IFRI/W16C01/00000577",
        "22/IFRI/W09C02/00011558",
        "22/IFRI/W09C02/00010780",
        "22/IFRI/W09C02/00013682",
        "22/IFRI/W09C02/00011326",
        "25/IFRI/W16C01/00000071",
        "23/IFRI/W16C01/00000097",
        "22/IFRI/W09C02/00012734",
        "25/IFRI/W16C01/00000192",
        "22/IFRI/W09C02/00010038",
        "23/IFRI/W16C01/00000561",
        "22/IFRI/W16C01/00001170",
        "23/IFRI/W16C01/00000521",
        "24/IFRI/W16C01/00000287",
        "23/IFRI/W16C01/00000538",
        "23/IFRI/W09C02/00000303",
        "24/IFRI/W16C01/00000295",
        "22/IFRI/W09C02/00012746",
        "22/IFRI/W09C02/00014245",
        "793_1746530645474",
        "23/IFRI/W16C01/00000191",
        "22/IFRI/W09C02/00013254",
        "24/IFRI/W16C01/00000288",
        "22/IFRI/W16C01/00000494",
        "22/IFRI/W09C02/00014283",
        "25/IFRI/W16C01/00000210",
        "23/IFRI/W09C02/00000018",
        "22/IFRI/W16C01/00001310",
        "23/IFRI/W16C01/00000603",
        "22/IFRI/W16C01/00000191",
        "24/IFRI/W16C01/00000322",
        "24/IFRI/W16C01/00000283",
        "22/IFRI/W09C02/00010553",
        "22/IFRI/W09C02/00010374",
        "22/IFRI/W16C01/00000544",
        "24/IFRI/W16C01/00000300",
        "25/IFRI/W16C01/00000211",
        "23/IFRI/W16C01/00000610",
        "22/IFRI/W16C01/00001329",
        "22/IFRI/W09C02/00013400",
        "24/IFRI/W16C01/00000335",
        "23/IFRI/W16C01/00000599",
        "22/IFRI/W09C02/00010326",
        "23/IFRI/W09C02/00000728",
        "22/IFRI/W09C02/00010245",
        "22/IFRI/W16C01/00000787",
        "22/IFRI/W09C02/00013352",
        "22/IFRI/W16C01/00000385",
        "23/IFRI/W16C01/00000432",
        "24/IFRI/W16C01/00000040",
        "23/IFRI/W16C01/00000605",
        "24/IFRI/W16C01/00000184",
        "22/IFRI/W09C02/00011270",
        "22/IFRI/W09C02/00009943",
        "22/IFRI/W09C02/00010931",
        "23/IFRI/W16C01/00000213",
        "23/IFRI/W16C01/00000181",
        "22/IFRI/W16C01/00000778",
        "22/IFRI/W09C02/00012665",
        "24/IFRI/W16C01/00000245",
        "25/IFRI/W16C01/00000158",
        "24/IFRI/W16C01/00000372",
        "22/IFRI/W16C01/00000438",
        "22/IFRI/W09C02/00011171",
        "22/IFRI/W09C02/00011500",
        "22/IFRI/W09C02/00011141",
        "23/IFRI/W16C01/00000413",
        "24/IFRI/W16C01/00000183",
        "22/IFRI/W09C02/00010287",
        "22/IFRI/W09C02/00010373",
        "22/IFRI/W09C02/00013407",
        "22/IFRI/W09C02/00011526",
        "22/IFRI/W16C01/00001332",
        "22/IFRI/W09C02/00011420",
        "24/IFRI/W16C01/00000333",
        "21/IFRI/06/00003488",
        "25/IFRI/W16C01/00000087",
        "22/IFRI/W16C01/00000694",
        "22/IFRI/W09C02/00013417",
        "22/IFRI/W09C02/00011105",
        "22/IFRI/W16C01/00001293",
        "22/IFRI/W09C02/00010322",
        "22/IFRI/W09C02/00011153",
        "22/IFRI/W16C01/00000500",
        "22/IFRI/W09C02/00014208",
        "25/IFRI/W16C01/00000159",
        "22/IFRI/W16C01/00000281",
        "22/IFRI/W16C01/00000988",
        "22/IFRI/W16C01/00000995",
        "22/IFRI/W09C02/00010192",
        "22/IFRI/W09C02/00009974",
        "25/IFRI/W16C01/00000170",
        "22/IFRI/W09C02/00011133",
        "22/IFRI/W09C02/00010130",
        "25/IFRI/W16C01/00000003",
        "22/IFRI/W09C02/00011840",
        "22/IFRI/W09C02/00011600",
        "2869_1748950098966",
        "22/IFRI/W16C01/00001284",
        "22/IFRI/W16C01/00000999",
        "23/IFRI/W16C01/00000198",
        "23/IFRI/W16C01/00000485",
        "22/IFRI/W09C02/00012190",
        "24/IFRI/W16C01/00000319",
        "23/IFRI/W16C01/00000595",
        "23/IFRI/W16C01/00000623",
        "23/IFRI/W16C01/00000589",
        "24/IFRI/W16C01/00000379",
        "24/IFRI/W16C01/00000386",
        "25/IFRI/W16C01/00000028",
        "24/IFRI/W16C01/00000128",
        "23/IFRI/03/00000238",
        "23/IFRI/W16C01/00000157",
        "24/IFRI/W16C01/00000297",
        "25/IFRI/W16C01/00000198",
        "23/IFRI/W16C01/00000106",
        "792_1746007466825",
        "22/IFRI/W09C02/00010738",
        "23/IFRI/W16C01/00000484",
        "23/IFRI/W16C01/00000137",
        "25/IFRI/W16C01/00000154",
        "22/IFRI/W16C01/00000885",
        "23/IFRI/W16C01/00000414",
        "23/IFRI/W16C01/00000102",
        "22/IFRI/W09C02/00010030",
        "22/IFRI/W16C01/00000651",
        "22/IFRI/W09C02/00011156",
        "22/IFRI/W09C02/00010290",
        "22/IFRI/W09C02/00010260",
        "22/IFRI/W09C02/00010772",
        "22/IFRI/W09C02/00013512",
        "22/IFRI/W09C02/00009999",
        "22/IFRI/W09C02/00010562",
        "24/IFRI/W16C01/00000373",
        "22/IFRI/W16C01/00000639",
        "25/IFRI/W16C01/00000180",
        "23/IFRI/W16C01/00000497",
        "22/IFRI/W09C02/00011129",
        "22/IFRI/W09C02/00010437",
        "23/IFRI/W16C01/00000479",
        "23/IFRI/W16C01/00000590",
        "23/IFRI/W16C01/00000483",
        "24/IFRI/W16C01/00000154",
        "24/IFRI/W16C01/00000247",
        "22/IFRI/W09C02/00011509",
        "22/IFRI/W16C01/00000975",
        "23/IFRI/W16C01/00000591",
        "22/IFRI/W09C02/00009854",
        "25/IFRI/W16C01/00000174",
        "22/IFRI/W09C02/00011348",
        "22/IFRI/W16C01/00001306",
        "23/IFRI/W16C01/00000104",
        "24/IFRI/W16C01/00000074",
        "24/IFRI/W16C01/00000306",
        "22/IFRI/W16C01/00000993",
        "22/IFRI/W09C02/00014153",
        "24/IFRI/W16C01/00000337",
        "23/IFRI/W16C01/00000480",
        "23/IFRI/W09C02/00000017",
        "23/IFRI/W16C01/00000460",
        "22/IFRI/W16C01/00000626",
        "23/IFRI/W16C01/00000344",
        "22/IFRI/W16C01/00000655",
        "24/IFRI/W16C01/00000132",
        "24/IFRI/W16C01/00000360",
        "25/IFRI/W16C01/00000069",
        "22/IFRI/W09C02/00010807",
        "22/IFRI/W09C02/00011387",
        "23/IFRI/W16C01/00000281",
        "22/IFRI/W09C02/00011425",
        "25/IFRI/W16C01/00000106",
        "25/IFRI/W16C01/00000176",
        "22/IFRI/W09C02/00011195",
        "23/IFRI/W16C01/00000391",
        "25/IFRI/W16C01/00000017",
        "24/IFRI/W16C01/00000179",
        "22/IFRI/W16C01/00000457",
        "22/IFRI/W09C02/00013419",
        "25/IFRI/W16C01/00000041",
        "23/IFRI/W09C02/00000076",
        "24/IFRI/W16C01/00000027",
        "22/IFRI/W09C02/00010763",
        "23/IFRI/W16C01/00000192",
        "23/IFRI/W09C02/00000290",
        "24/IFRI/W16C01/00000254",
        "23/IFRI/W16C01/00000466",
        "22/IFRI/W09C02/00010041",
        "22/IFRI/W09C02/00010151",
        "22/IFRI/W09C02/00010074",
        "22/IFRI/W09C02/00014048",
        "24/IFRI/W16C01/00000070",
        "22/IFRI/W09C02/00011252",
        "22/IFRI/W09C02/00010706",
        "23/IFRI/W16C01/00000392",
        "25/IFRI/W16C01/00000005",
        "25/IFRI/W16C01/00000018",
        "22/IFRI/W09C02/00013469",
        "22/IFRI/W16C01/00000502",
        "24/IFRI/W16C01/00000119",
        "24/IFRI/W16C01/00000016",
        "22/IFRI/W16C01/00000479",
        "25/IFRI/W16C01/00000109",
        "23/IFRI/W16C01/00000393",
        "22/IFRI/W16C01/00000767",
        "23/IFRI/W16C01/00000559",
        "23/IFRI/W16C01/00000467",
        "23/IFRI/W16C01/00000095",
        "24/IFRI/W16C01/00000369",
        "23/IFRI/W09C02/00000369",
        "23/IFRI/W16C01/00000201",
        "22/IFRI/W16C01/00001286",
        "23/IFRI/W16C01/00000403",
        "24/IFRI/W16C01/00000143",
        "23/IFRI/W16C01/00000549",
        "24/IFRI/W16C01/00000124",
        "25/IFRI/W16C01/00000053",
        "23/IFRI/W16C01/00000096",
        "23/IFRI/W16C01/00000550",
        "22/IFRI/W09C02/00009947",
        "23/IFRI/W16C01/00000203",
        "22/IFRI/W16C01/00000239",
        "24/IFRI/W16C01/00000120",
        "22/IFRI/W16C01/00000328",
        "22/IFRI/W16C01/00000301",
        "22/IFRI/W16C01/00000426",
        "22/IFRI/W09C02/00011598",
        "22/IFRI/W09C02/00010556",
        "24/IFRI/W16C01/00000296",
        "25/IFRI/W16C01/00000146",
        "22/IFRI/W09C02/00012525",
        "22/IFRI/W09C02/00010054",
        "24/IFRI/W16C01/00000259",
        "25/IFRI/W16C01/00000196",
        "24/IFRI/W36C01/00000035",
        "22/IFRI/W09C02/00011465",
        "23/IFRI/W16C01/00000465",
        "24/IFRI/W16C01/00000241",
        "22/IFRI/W09C02/00014111",
        "22/IFRI/W09C02/00009846",
        "25/IFRI/W16C01/00000189",
        "22/IFRI/W16C01/00001309",
        "22/IFRI/W09C02/00010376",
        "22/IFRI/W16C01/00001289",
        "23/IFRI/W16C01/00000468",
        "22/IFRI/W09C02/00011143",
        "22/IFRI/W09C02/00011142",
        "23/IFRI/W16C01/00000574",
        "22/IFRI/W09C02/00011827",
        "24/IFRI/W16C01/00000084",
        "25/IFRI/W16C01/00000070",
        "25/IFRI/W16C01/00000012",
        "25/IFRI/W16C01/00000148",
        "22/IFRI/W09C02/00009908",
        "22/IFRI/W09C02/00012725",
        "23/IFRI/W16C01/00000593",
        "23/IFRI/W16C01/00000612",
        "23/IFRI/W16C01/00000541",
        "22/IFRI/W09C02/00013619",
        "22/IFRI/W09C02/00010146",
        "22/IFRI/W09C02/00010314",
        "22/IFRI/W09C02/00011157",
        "1406_1746101876205",
        "25/IFRI/W16C01/00000102",
        "22/IFRI/W09C02/00013253",
        "23/IFRI/W16C01/00000481",
        "25/IFRI/W16C01/00000059",
        "23/IFRI/W16C01/00000041",
        "24/IFRI/W16C01/00000081",
        "22/IFRI/W16C01/00001302",
        "22/IFRI/W09C02/00011341",
        "22/IFRI/W16C01/00000770",
        "22/IFRI/W09C02/00010727",
        "22/IFRI/W16C01/00000553",
        "23/IFRI/W09C02/00000014",
        "22/IFRI/W09C02/00011570",
        "22/IFRI/W16C01/00000991",
        "23/IFRI/W16C01/00000548",
        "22/IFRI/W09C02/00010345",
        "22/IFRI/W16C01/00000835",
        "22/IFRI/W09C02/00010497",
        "23/IFRI/W16C01/00000503",
        "24/IFRI/W16C01/00000282",
        "22/IFRI/W16C01/00000649",
        "22/IFRI/W16C01/00000162",
        "24/IFRI/W16C01/00000239",
        "23/IFRI/W16C01/00000054",
        "22/IFRI/W09C02/00011611",
        "23/IFRI/W16C01/00000506",
        "22/IFRI/W16C01/00000647",
        "22/IFRI/W16C01/00001001",
        "22/IFRI/W16C01/00001308",
        "23/IFRI/W16C01/00000047",
        "22/IFRI/W09C02/00014038",
        "22/IFRI/W16C01/00001005",
        "25/IFRI/W16C01/00000185",
        "22/IFRI/W09C02/00009993",
        "22/IFRI/W09C02/00012731",
        "22/IFRI/W09C02/00010893",
        "22/IFRI/W09C02/00010135",
        "23/IFRI/W09C02/00000368",
        "22/IFRI/W09C02/00010890",
        "23/IFRI/W09C02/00000293",
        "22/IFRI/W09C02/00013245",
        "22/IFRI/W09C02/00011145",
        "25/IFRI/W16C01/00000067",
        "24/IFRI/W16C01/00000246",
        "22/IFRI/W16C01/00000658",
        "22/IFRI/W16C01/00000414",
        "22/IFRI/W16C01/00001088",
        "23/IFRI/W16C01/00000223",
        "22/IFRI/W16C01/00001305",
        "25/IFRI/W16C01/00000142",
        "22/IFRI/W09C02/00011137",
        "25/IFRI/W16C01/00000168",
        "24/IFRI/W16C01/00000091",
        "22/IFRI/W16C01/00000977",
        "23/IFRI/W16C01/00000470",
        "23/IFRI/W09C02/00000301",
        "23/IFRI/W16C01/00000384",
        "22/IFRI/W09C02/00013239",
        "22/IFRI/W09C02/00011615",
        "24/IFRI/W16C01/00000162",
        "22/IFRI/W16C01/00000743",
        "23/IFRI/W16C01/00000066",
        "22/IFRI/W09C02/00011610",
        "22/IFRI/W09C02/00010224",
        "22/IFRI/W09C02/00011177",
        "23/IFRI/W16C01/00000339",
        "24/IFRI/W16C01/00000284",
        "22/IFRI/W09C02/00014155",
        "22/IFRI/W16C01/00000852",
        "22/IFRI/W09C02/00013560",
        "23/IFRI/W16C01/00000597",
        "23/IFRI/W16C01/00000165",
        "22/IFRI/W09C02/00011351",
        "23/IFRI/W09C02/00000300",
        "22/IFRI/W09C02/00011128",
        "25/IFRI/W16C01/00000111",
        "24/IFRI/W16C01/00000263",
        "25/IFRI/W16C01/00000151",
        "22/IFRI/W09C02/00011973",
        "22/IFRI/W09C02/00011242",
        "24/IFRI/W16C01/00000018",
        "23/IFRI/W16C01/00000402",
        "23/IFRI/W09C02/00000011",
        "22/IFRI/W16C01/00001171",
        "24/IFRI/W16C01/00000055",
        "23/IFRI/W09C02/00000730",
        "24/IFRI/W16C01/00000358",
        "22/IFRI/W09C02/00013571",
        "23/IFRI/W16C01/00000236",
        "22/IFRI/W09C02/00011333",
        "22/IFRI/W09C02/00011471",
        "23/IFRI/W16C01/00000535",
        "21/IFRI/06/00006753",
        "25/IFRI/W16C01/00000098",
        "22/IFRI/W16C01/00000976",
        "24/IFRI/W16C01/00000142",
        "23/IFRI/W16C01/00000471",
        "22/IFRI/W09C02/00009957",
        "23/IFRI/W16C01/00000598",
        "23/IFRI/W16C01/00000254",
        "25/IFRI/W16C01/00000143",
        "23/IFRI/W16C01/00000507",
        "22/IFRI/W09C02/00009843",
        "24/IFRI/W16C01/00000260",
        "22/IFRI/W09C02/00011165",
        "22/IFRI/W09C02/00012422",
        "25/IFRI/W16C01/00000010",
        "22/IFRI/W16C01/00000645",
        "22/IFRI/W09C02/00012307",
        "22/IFRI/W16C01/00000254",
        "24/IFRI/W16C01/00000024",
        "22/IFRI/W16C01/00000660",
        "23/IFRI/W09C02/00000047",
        "22/IFRI/W09C02/00013586",
        "24/IFRI/W16C01/00000180",
        "22/IFRI/W16C01/00000549",
        "22/IFRI/W09C02/00011328",
        "24/IFRI/W16C01/00000087",
        "23/IFRI/W16C01/00000091",
        "23/IFRI/W16C01/00000600",
        "22/IFRI/W09C02/00014081",
        "22/IFRI/W09C02/00011820",
        "22/IFRI/W09C02/00013413",
        "22/IFRI/W09C02/00012308",
        "24/IFRI/W16C01/00000112",
        "24/IFRI/W16C01/00000149",
        "23/IFRI/W16C01/00000385",
        "24/IFRI/W16C01/00000076",
        "24/IFRI/W16C01/00000308",
        "21/IFRI/03/00001389",
        "21/IFRI/06/00007708",
        "21/IFRI/03/00001280",
        "23/IFRI/W16C02/00000300",
        "22/IFRI/W16C02/00000239",
        "21/IFRI/03/00001322",
        "22/IFRI/W09C02/00007710",
        "22/IFRI/W16C02/00000713",
        "21/IFRI/06/00008332",
        "21/IFRI/06/00008249",
        "22/IFRI/W09C02/00008642",
        "22/IFRI/W09C02/00008020",
        "22/IFRI/W16C02/00001029",
        "21/IFRI/03/00001235",
        "25/IFRI/W16C02/00000077",
        "21/IFRI/03/00001223",
        "21/IFRI/03/00001038",
        "22/IFRI/W09C02/00004762",
        "21/IFRI/06/00010028",
        "22/IFRI/W16C02/00000226",
        "22/IFRI/W16C02/00000637",
        "21/IFRI/03/00001326",
        "21/IFRI/03/00001042",
        "21/IFRI/06/00002269",
        "21/IFRI/06/00003521",
        "22/IFRI/W09C02/00011464",
        "21/IFRI/06/00007243",
        "21/IFRI/06/00005601",
        "21/IFRI/06/00003466",
        "22/IFRI/W16C02/00000964",
        "23/IFRI/03/00000382",
        "22/IFRI/W16C02/00001016",
        "21/IFRI/06/00006741",
        "21/IFRI/06/00002740",
        "24/IFRI/03/00000196",
        "21/IFRI/06/00000396",
        "21/IFRI/06/00007207",
        "22/IFRI/W09C02/00000023",
        "22/IFRI/W09C02/00003709",
        "21/IFRI/06/00003474",
        "21/IFRI/06/00006762",
        "23/IFRI/03/00000124",
        "21/IFRI/06/00003463",
        "21/IFRI/06/00003527",
        "21/IFRI/06/00005627",
        "21/IFRI/06/00007225",
        "21/IFRI/06/00006340",
        "23/IFRI/W16C04/00003364",
        "24/IFRI/W16C04/00000240",
        "22/IFRI/W16C04/00003654",
        "24/IFRI/W16C04/00000083",
        "25/IFRI/W16C01/00000105",
      ]
    }
  }
};
</script>

<style scoped></style>
